// @ts-nocheck
/* eslint-disable */
// Generated from ./src/antlr/ManimParser.g4 by ANTLR 4.7.3-SNAPSHOT


import { ATN } from "antlr4ts/atn/ATN";
import { ATNDeserializer } from "antlr4ts/atn/ATNDeserializer";
import { FailedPredicateException } from "antlr4ts/FailedPredicateException";
import { NotNull } from "antlr4ts/Decorators";
import { NoViableAltException } from "antlr4ts/NoViableAltException";
import { Override } from "antlr4ts/Decorators";
import { Parser } from "antlr4ts/Parser";
import { ParserRuleContext } from "antlr4ts/ParserRuleContext";
import { ParserATNSimulator } from "antlr4ts/atn/ParserATNSimulator";
import { ParseTreeListener } from "antlr4ts/tree/ParseTreeListener";
import { ParseTreeVisitor } from "antlr4ts/tree/ParseTreeVisitor";
import { RecognitionException } from "antlr4ts/RecognitionException";
import { RuleContext } from "antlr4ts/RuleContext";
//import { RuleVersion } from "antlr4ts/RuleVersion";
import { TerminalNode } from "antlr4ts/tree/TerminalNode";
import { Token } from "antlr4ts/Token";
import { TokenStream } from "antlr4ts/TokenStream";
import { Vocabulary } from "antlr4ts/Vocabulary";
import { VocabularyImpl } from "antlr4ts/VocabularyImpl";

import * as Utils from "antlr4ts/misc/Utils";

import { ManimParserListener } from "./ManimParserListener";
import { ManimParserVisitor } from "./ManimParserVisitor";


export class ManimParser extends Parser {
	public static readonly WHITESPACE = 1;
	public static readonly SEMI = 2;
	public static readonly COLON = 3;
	public static readonly DOT = 4;
	public static readonly EQUAL = 5;
	public static readonly COMMA = 6;
	public static readonly AT = 7;
	public static readonly TRUE = 8;
	public static readonly FALSE = 9;
	public static readonly ADD = 10;
	public static readonly MINUS = 11;
	public static readonly TIMES = 12;
	public static readonly DIVIDE = 13;
	public static readonly LT = 14;
	public static readonly GT = 15;
	public static readonly GE = 16;
	public static readonly LE = 17;
	public static readonly EQ = 18;
	public static readonly NEQ = 19;
	public static readonly AND = 20;
	public static readonly OR = 21;
	public static readonly NOT = 22;
	public static readonly OPEN_PARENTHESIS = 23;
	public static readonly CLOSE_PARENTHESIS = 24;
	public static readonly OPEN_CURLY_BRACKET = 25;
	public static readonly CLOSE_CURLY_BRACKET = 26;
	public static readonly OPEN_SQUARE_BRACKET = 27;
	public static readonly CLOSE_SQUARE_BRACKET = 28;
	public static readonly CODE_COMMENT = 29;
	public static readonly LET = 30;
	public static readonly FUN = 31;
	public static readonly RETURN = 32;
	public static readonly NUMBER_TYPE = 33;
	public static readonly BOOL_TYPE = 34;
	public static readonly CHAR_TYPE = 35;
	public static readonly STRING_TYPE = 36;
	public static readonly COMMENT = 37;
	public static readonly SLEEP = 38;
	public static readonly STACK = 39;
	public static readonly ARRAY = 40;
	public static readonly LIST = 41;
	public static readonly TREE = 42;
	public static readonly TREE_NODE = 43;
	public static readonly IF = 44;
	public static readonly ELSE = 45;
	public static readonly WHILE = 46;
	public static readonly FOR = 47;
	public static readonly IN = 48;
	public static readonly RANGE = 49;
	public static readonly BREAK = 50;
	public static readonly CONTINUE = 51;
	public static readonly TO_NUMBER = 52;
	public static readonly TO_CHAR = 53;
	public static readonly STEP_INTO = 54;
	public static readonly STEP_OVER = 55;
	public static readonly SPEED = 56;
	public static readonly SUBTITLE = 57;
	public static readonly SUBTITLE_ONCE = 58;
	public static readonly NULL = 59;
	public static readonly IDENT = 60;
	public static readonly NUMBER = 61;
	public static readonly STRING = 62;
	public static readonly CHAR_LITER = 63;
	public static readonly RULE_program = 0;
	public static readonly RULE_function = 1;
	public static readonly RULE_param_list = 2;
	public static readonly RULE_param = 3;
	public static readonly RULE_stat = 4;
	public static readonly RULE_annotation = 5;
	public static readonly RULE_forHeader = 6;
	public static readonly RULE_loop_stat = 7;
	public static readonly RULE_assignment_lhs = 8;
	public static readonly RULE_elseIf = 9;
	public static readonly RULE_arg_list = 10;
	public static readonly RULE_expr = 11;
	public static readonly RULE_cast_method = 12;
	public static readonly RULE_method_call = 13;
	public static readonly RULE_type = 14;
	public static readonly RULE_node_type = 15;
	public static readonly RULE_data_structure_type = 16;
	public static readonly RULE_primitive_type = 17;
	public static readonly RULE_bool = 18;
	public static readonly RULE_data_structure_initialiser = 19;
	public static readonly RULE_initialiser_list = 20;
	public static readonly RULE_array_elem = 21;
	public static readonly RULE_node_elem = 22;
	public static readonly RULE_node_elem_access = 23;
	// tslint:disable:no-trailing-whitespace
	public static readonly ruleNames: string[] = [
		"program", "function", "param_list", "param", "stat", "annotation", "forHeader", 
		"loop_stat", "assignment_lhs", "elseIf", "arg_list", "expr", "cast_method", 
		"method_call", "type", "node_type", "data_structure_type", "primitive_type", 
		"bool", "data_structure_initialiser", "initialiser_list", "array_elem", 
		"node_elem", "node_elem_access",
	];

	private static readonly _LITERAL_NAMES: Array<string | undefined> = [
		undefined, undefined, "';'", "':'", "'.'", "'='", "','", "'@'", "'true'", 
		"'false'", "'+'", "'-'", "'*'", "'/'", "'<'", "'>'", "'>='", "'<='", "'=='", 
		"'!='", "'&&'", "'||'", "'!'", "'('", "')'", "'{'", "'}'", "'['", "']'", 
		undefined, "'let'", "'fun'", "'return'", "'number'", "'boolean'", "'char'", 
		"'string'", "'comment'", "'sleep'", "'Stack'", "'Array'", "'List'", "'Tree'", 
		"'Node'", "'if'", "'else'", "'while'", "'for'", "'in'", "'range'", "'break'", 
		"'continue'", "'toNumber'", "'toChar'", "'@stepInto'", "'@stepOver'", 
		"'@speed'", "'@subtitle'", "'@subtitleOnce'", "'null'",
	];
	private static readonly _SYMBOLIC_NAMES: Array<string | undefined> = [
		undefined, "WHITESPACE", "SEMI", "COLON", "DOT", "EQUAL", "COMMA", "AT", 
		"TRUE", "FALSE", "ADD", "MINUS", "TIMES", "DIVIDE", "LT", "GT", "GE", 
		"LE", "EQ", "NEQ", "AND", "OR", "NOT", "OPEN_PARENTHESIS", "CLOSE_PARENTHESIS", 
		"OPEN_CURLY_BRACKET", "CLOSE_CURLY_BRACKET", "OPEN_SQUARE_BRACKET", "CLOSE_SQUARE_BRACKET", 
		"CODE_COMMENT", "LET", "FUN", "RETURN", "NUMBER_TYPE", "BOOL_TYPE", "CHAR_TYPE", 
		"STRING_TYPE", "COMMENT", "SLEEP", "STACK", "ARRAY", "LIST", "TREE", "TREE_NODE", 
		"IF", "ELSE", "WHILE", "FOR", "IN", "RANGE", "BREAK", "CONTINUE", "TO_NUMBER", 
		"TO_CHAR", "STEP_INTO", "STEP_OVER", "SPEED", "SUBTITLE", "SUBTITLE_ONCE", 
		"NULL", "IDENT", "NUMBER", "STRING", "CHAR_LITER",
	];
	public static readonly VOCABULARY: Vocabulary = new VocabularyImpl(ManimParser._LITERAL_NAMES, ManimParser._SYMBOLIC_NAMES, []);

	// @Override
	// @NotNull
	public get vocabulary(): Vocabulary {
		return ManimParser.VOCABULARY;
	}
	// tslint:enable:no-trailing-whitespace

	// @Override
	public get grammarFileName(): string { return "ManimParser.g4"; }

	// @Override
	public get ruleNames(): string[] { return ManimParser.ruleNames; }

	// @Override
	public get serializedATN(): string { return ManimParser._serializedATN; }

	constructor(input: TokenStream) {
		super(input);
		this._interp = new ParserATNSimulator(ManimParser._ATN, this);
	}
	// @RuleVersion(0)
	public program(): ProgramContext {
		let _localctx: ProgramContext = new ProgramContext(this._ctx, this.state);
		this.enterRule(_localctx, 0, ManimParser.RULE_program);
		let _la: number;
		try {
			this.enterOuterAlt(_localctx, 1);
			{
			this.state = 51;
			this._errHandler.sync(this);
			_la = this._input.LA(1);
			while (_la === ManimParser.FUN) {
				{
				{
				this.state = 48;
				this.function();
				}
				}
				this.state = 53;
				this._errHandler.sync(this);
				_la = this._input.LA(1);
			}
			this.state = 54;
			this.stat(0);
			this.state = 55;
			this.match(ManimParser.EOF);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				_localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return _localctx;
	}
	// @RuleVersion(0)
	public function(): FunctionContext {
		let _localctx: FunctionContext = new FunctionContext(this._ctx, this.state);
		this.enterRule(_localctx, 2, ManimParser.RULE_function);
		let _la: number;
		try {
			this.enterOuterAlt(_localctx, 1);
			{
			this.state = 57;
			this.match(ManimParser.FUN);
			this.state = 58;
			this.match(ManimParser.IDENT);
			this.state = 59;
			this.match(ManimParser.OPEN_PARENTHESIS);
			this.state = 61;
			this._errHandler.sync(this);
			_la = this._input.LA(1);
			if (_la === ManimParser.IDENT) {
				{
				this.state = 60;
				this.param_list();
				}
			}

			this.state = 63;
			this.match(ManimParser.CLOSE_PARENTHESIS);
			this.state = 66;
			this._errHandler.sync(this);
			_la = this._input.LA(1);
			if (_la === ManimParser.COLON) {
				{
				this.state = 64;
				this.match(ManimParser.COLON);
				this.state = 65;
				this.type();
				}
			}

			this.state = 68;
			this.match(ManimParser.OPEN_CURLY_BRACKET);
			this.state = 70;
			this._errHandler.sync(this);
			_la = this._input.LA(1);
			if (((((_la - 30)) & ~0x1F) === 0 && ((1 << (_la - 30)) & ((1 << (ManimParser.LET - 30)) | (1 << (ManimParser.RETURN - 30)) | (1 << (ManimParser.SLEEP - 30)) | (1 << (ManimParser.IF - 30)) | (1 << (ManimParser.WHILE - 30)) | (1 << (ManimParser.FOR - 30)) | (1 << (ManimParser.BREAK - 30)) | (1 << (ManimParser.CONTINUE - 30)) | (1 << (ManimParser.STEP_INTO - 30)) | (1 << (ManimParser.STEP_OVER - 30)) | (1 << (ManimParser.SPEED - 30)) | (1 << (ManimParser.SUBTITLE - 30)) | (1 << (ManimParser.SUBTITLE_ONCE - 30)) | (1 << (ManimParser.IDENT - 30)))) !== 0)) {
				{
				this.state = 69;
				_localctx._statements = this.stat(0);
				}
			}

			this.state = 72;
			this.match(ManimParser.CLOSE_CURLY_BRACKET);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				_localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return _localctx;
	}
	// @RuleVersion(0)
	public param_list(): Param_listContext {
		let _localctx: Param_listContext = new Param_listContext(this._ctx, this.state);
		this.enterRule(_localctx, 4, ManimParser.RULE_param_list);
		let _la: number;
		try {
			_localctx = new ParameterListContext(_localctx);
			this.enterOuterAlt(_localctx, 1);
			{
			this.state = 74;
			this.param();
			this.state = 79;
			this._errHandler.sync(this);
			_la = this._input.LA(1);
			while (_la === ManimParser.COMMA) {
				{
				{
				this.state = 75;
				this.match(ManimParser.COMMA);
				this.state = 76;
				this.param();
				}
				}
				this.state = 81;
				this._errHandler.sync(this);
				_la = this._input.LA(1);
			}
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				_localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return _localctx;
	}
	// @RuleVersion(0)
	public param(): ParamContext {
		let _localctx: ParamContext = new ParamContext(this._ctx, this.state);
		this.enterRule(_localctx, 6, ManimParser.RULE_param);
		try {
			_localctx = new ParameterContext(_localctx);
			this.enterOuterAlt(_localctx, 1);
			{
			this.state = 82;
			this.match(ManimParser.IDENT);
			this.state = 83;
			this.match(ManimParser.COLON);
			this.state = 84;
			this.type();
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				_localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return _localctx;
	}

	public stat(): StatContext;
	public stat(_p: number): StatContext;
	// @RuleVersion(0)
	public stat(_p?: number): StatContext {
		if (_p === undefined) {
			_p = 0;
		}

		let _parentctx: ParserRuleContext = this._ctx;
		let _parentState: number = this.state;
		let _localctx: StatContext = new StatContext(this._ctx, _parentState);
		let _prevctx: StatContext = _localctx;
		let _startState: number = 8;
		this.enterRecursionRule(_localctx, 8, ManimParser.RULE_stat, _p);
		let _la: number;
		try {
			let _alt: number;
			this.enterOuterAlt(_localctx, 1);
			{
			this.state = 159;
			this._errHandler.sync(this);
			switch ( this.interpreter.adaptivePredict(this._input, 13, this._ctx) ) {
			case 1:
				{
				_localctx = new SleepStatementContext(_localctx);
				this._ctx = _localctx;
				_prevctx = _localctx;

				this.state = 87;
				this.match(ManimParser.SLEEP);
				this.state = 88;
				this.match(ManimParser.OPEN_PARENTHESIS);
				this.state = 89;
				this.expr(0);
				this.state = 90;
				this.match(ManimParser.CLOSE_PARENTHESIS);
				this.state = 91;
				this.match(ManimParser.SEMI);
				}
				break;

			case 2:
				{
				_localctx = new DeclarationStatementContext(_localctx);
				this._ctx = _localctx;
				_prevctx = _localctx;
				this.state = 93;
				this.match(ManimParser.LET);
				this.state = 94;
				this.match(ManimParser.IDENT);
				this.state = 97;
				this._errHandler.sync(this);
				_la = this._input.LA(1);
				if (_la === ManimParser.COLON) {
					{
					this.state = 95;
					this.match(ManimParser.COLON);
					this.state = 96;
					this.type();
					}
				}

				this.state = 99;
				this.match(ManimParser.EQUAL);
				this.state = 100;
				this.expr(0);
				this.state = 101;
				this.match(ManimParser.SEMI);
				}
				break;

			case 3:
				{
				_localctx = new AssignmentStatementContext(_localctx);
				this._ctx = _localctx;
				_prevctx = _localctx;
				this.state = 103;
				this.assignment_lhs();
				this.state = 104;
				this.match(ManimParser.EQUAL);
				this.state = 105;
				this.expr(0);
				this.state = 106;
				this.match(ManimParser.SEMI);
				}
				break;

			case 4:
				{
				_localctx = new IfStatementContext(_localctx);
				this._ctx = _localctx;
				_prevctx = _localctx;
				this.state = 108;
				this.match(ManimParser.IF);
				this.state = 109;
				this.match(ManimParser.OPEN_PARENTHESIS);
				this.state = 110;
				(_localctx as IfStatementContext)._ifCond = this.expr(0);
				this.state = 111;
				this.match(ManimParser.CLOSE_PARENTHESIS);
				this.state = 112;
				this.match(ManimParser.OPEN_CURLY_BRACKET);
				this.state = 114;
				this._errHandler.sync(this);
				_la = this._input.LA(1);
				if (((((_la - 30)) & ~0x1F) === 0 && ((1 << (_la - 30)) & ((1 << (ManimParser.LET - 30)) | (1 << (ManimParser.RETURN - 30)) | (1 << (ManimParser.SLEEP - 30)) | (1 << (ManimParser.IF - 30)) | (1 << (ManimParser.WHILE - 30)) | (1 << (ManimParser.FOR - 30)) | (1 << (ManimParser.BREAK - 30)) | (1 << (ManimParser.CONTINUE - 30)) | (1 << (ManimParser.STEP_INTO - 30)) | (1 << (ManimParser.STEP_OVER - 30)) | (1 << (ManimParser.SPEED - 30)) | (1 << (ManimParser.SUBTITLE - 30)) | (1 << (ManimParser.SUBTITLE_ONCE - 30)) | (1 << (ManimParser.IDENT - 30)))) !== 0)) {
					{
					this.state = 113;
					(_localctx as IfStatementContext)._ifStat = this.stat(0);
					}
				}

				this.state = 116;
				this.match(ManimParser.CLOSE_CURLY_BRACKET);
				this.state = 120;
				this._errHandler.sync(this);
				_alt = this.interpreter.adaptivePredict(this._input, 7, this._ctx);
				while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
					if (_alt === 1) {
						{
						{
						this.state = 117;
						this.elseIf();
						}
						}
					}
					this.state = 122;
					this._errHandler.sync(this);
					_alt = this.interpreter.adaptivePredict(this._input, 7, this._ctx);
				}
				this.state = 129;
				this._errHandler.sync(this);
				switch ( this.interpreter.adaptivePredict(this._input, 9, this._ctx) ) {
				case 1:
					{
					this.state = 123;
					this.match(ManimParser.ELSE);
					this.state = 124;
					this.match(ManimParser.OPEN_CURLY_BRACKET);
					this.state = 126;
					this._errHandler.sync(this);
					_la = this._input.LA(1);
					if (((((_la - 30)) & ~0x1F) === 0 && ((1 << (_la - 30)) & ((1 << (ManimParser.LET - 30)) | (1 << (ManimParser.RETURN - 30)) | (1 << (ManimParser.SLEEP - 30)) | (1 << (ManimParser.IF - 30)) | (1 << (ManimParser.WHILE - 30)) | (1 << (ManimParser.FOR - 30)) | (1 << (ManimParser.BREAK - 30)) | (1 << (ManimParser.CONTINUE - 30)) | (1 << (ManimParser.STEP_INTO - 30)) | (1 << (ManimParser.STEP_OVER - 30)) | (1 << (ManimParser.SPEED - 30)) | (1 << (ManimParser.SUBTITLE - 30)) | (1 << (ManimParser.SUBTITLE_ONCE - 30)) | (1 << (ManimParser.IDENT - 30)))) !== 0)) {
						{
						this.state = 125;
						(_localctx as IfStatementContext)._elseStat = this.stat(0);
						}
					}

					this.state = 128;
					this.match(ManimParser.CLOSE_CURLY_BRACKET);
					}
					break;
				}
				}
				break;

			case 5:
				{
				_localctx = new WhileStatementContext(_localctx);
				this._ctx = _localctx;
				_prevctx = _localctx;
				this.state = 131;
				this.match(ManimParser.WHILE);
				this.state = 132;
				this.match(ManimParser.OPEN_PARENTHESIS);
				this.state = 133;
				(_localctx as WhileStatementContext)._whileCond = this.expr(0);
				this.state = 134;
				this.match(ManimParser.CLOSE_PARENTHESIS);
				this.state = 135;
				this.match(ManimParser.OPEN_CURLY_BRACKET);
				this.state = 137;
				this._errHandler.sync(this);
				_la = this._input.LA(1);
				if (((((_la - 30)) & ~0x1F) === 0 && ((1 << (_la - 30)) & ((1 << (ManimParser.LET - 30)) | (1 << (ManimParser.RETURN - 30)) | (1 << (ManimParser.SLEEP - 30)) | (1 << (ManimParser.IF - 30)) | (1 << (ManimParser.WHILE - 30)) | (1 << (ManimParser.FOR - 30)) | (1 << (ManimParser.BREAK - 30)) | (1 << (ManimParser.CONTINUE - 30)) | (1 << (ManimParser.STEP_INTO - 30)) | (1 << (ManimParser.STEP_OVER - 30)) | (1 << (ManimParser.SPEED - 30)) | (1 << (ManimParser.SUBTITLE - 30)) | (1 << (ManimParser.SUBTITLE_ONCE - 30)) | (1 << (ManimParser.IDENT - 30)))) !== 0)) {
					{
					this.state = 136;
					(_localctx as WhileStatementContext)._whileStat = this.stat(0);
					}
				}

				this.state = 139;
				this.match(ManimParser.CLOSE_CURLY_BRACKET);
				}
				break;

			case 6:
				{
				_localctx = new ForStatementContext(_localctx);
				this._ctx = _localctx;
				_prevctx = _localctx;
				this.state = 141;
				this.match(ManimParser.FOR);
				this.state = 142;
				this.forHeader();
				this.state = 143;
				this.match(ManimParser.OPEN_CURLY_BRACKET);
				this.state = 145;
				this._errHandler.sync(this);
				_la = this._input.LA(1);
				if (((((_la - 30)) & ~0x1F) === 0 && ((1 << (_la - 30)) & ((1 << (ManimParser.LET - 30)) | (1 << (ManimParser.RETURN - 30)) | (1 << (ManimParser.SLEEP - 30)) | (1 << (ManimParser.IF - 30)) | (1 << (ManimParser.WHILE - 30)) | (1 << (ManimParser.FOR - 30)) | (1 << (ManimParser.BREAK - 30)) | (1 << (ManimParser.CONTINUE - 30)) | (1 << (ManimParser.STEP_INTO - 30)) | (1 << (ManimParser.STEP_OVER - 30)) | (1 << (ManimParser.SPEED - 30)) | (1 << (ManimParser.SUBTITLE - 30)) | (1 << (ManimParser.SUBTITLE_ONCE - 30)) | (1 << (ManimParser.IDENT - 30)))) !== 0)) {
					{
					this.state = 144;
					(_localctx as ForStatementContext)._forStat = this.stat(0);
					}
				}

				this.state = 147;
				this.match(ManimParser.CLOSE_CURLY_BRACKET);
				}
				break;

			case 7:
				{
				_localctx = new LoopStatementContext(_localctx);
				this._ctx = _localctx;
				_prevctx = _localctx;
				this.state = 149;
				this.loop_stat();
				}
				break;

			case 8:
				{
				_localctx = new MethodCallStatementContext(_localctx);
				this._ctx = _localctx;
				_prevctx = _localctx;
				this.state = 150;
				this.method_call();
				this.state = 151;
				this.match(ManimParser.SEMI);
				}
				break;

			case 9:
				{
				_localctx = new ReturnStatementContext(_localctx);
				this._ctx = _localctx;
				_prevctx = _localctx;
				this.state = 153;
				this.match(ManimParser.RETURN);
				this.state = 155;
				this._errHandler.sync(this);
				_la = this._input.LA(1);
				if ((((_la) & ~0x1F) === 0 && ((1 << _la) & ((1 << ManimParser.TRUE) | (1 << ManimParser.FALSE) | (1 << ManimParser.ADD) | (1 << ManimParser.MINUS) | (1 << ManimParser.NOT) | (1 << ManimParser.OPEN_PARENTHESIS))) !== 0) || ((((_la - 39)) & ~0x1F) === 0 && ((1 << (_la - 39)) & ((1 << (ManimParser.STACK - 39)) | (1 << (ManimParser.ARRAY - 39)) | (1 << (ManimParser.LIST - 39)) | (1 << (ManimParser.TREE - 39)) | (1 << (ManimParser.TREE_NODE - 39)) | (1 << (ManimParser.TO_NUMBER - 39)) | (1 << (ManimParser.TO_CHAR - 39)) | (1 << (ManimParser.NULL - 39)) | (1 << (ManimParser.IDENT - 39)) | (1 << (ManimParser.NUMBER - 39)) | (1 << (ManimParser.STRING - 39)) | (1 << (ManimParser.CHAR_LITER - 39)))) !== 0)) {
					{
					this.state = 154;
					this.expr(0);
					}
				}

				this.state = 157;
				this.match(ManimParser.SEMI);
				}
				break;

			case 10:
				{
				_localctx = new AnnotationStatementContext(_localctx);
				this._ctx = _localctx;
				_prevctx = _localctx;
				this.state = 158;
				this.annotation();
				}
				break;
			}
			this._ctx._stop = this._input.tryLT(-1);
			this.state = 165;
			this._errHandler.sync(this);
			_alt = this.interpreter.adaptivePredict(this._input, 14, this._ctx);
			while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
				if (_alt === 1) {
					if (this._parseListeners != null) {
						this.triggerExitRuleEvent();
					}
					_prevctx = _localctx;
					{
					{
					_localctx = new ConsecutiveStatementContext(new StatContext(_parentctx, _parentState));
					(_localctx as ConsecutiveStatementContext)._stat1 = _prevctx;
					this.pushNewRecursionContext(_localctx, _startState, ManimParser.RULE_stat);
					this.state = 161;
					if (!(this.precpred(this._ctx, 4))) {
						throw new FailedPredicateException(this, "this.precpred(this._ctx, 4)");
					}
					this.state = 162;
					(_localctx as ConsecutiveStatementContext)._stat2 = this.stat(5);
					}
					}
				}
				this.state = 167;
				this._errHandler.sync(this);
				_alt = this.interpreter.adaptivePredict(this._input, 14, this._ctx);
			}
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				_localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.unrollRecursionContexts(_parentctx);
		}
		return _localctx;
	}
	// @RuleVersion(0)
	public annotation(): AnnotationContext {
		let _localctx: AnnotationContext = new AnnotationContext(this._ctx, this.state);
		this.enterRule(_localctx, 10, ManimParser.RULE_annotation);
		let _la: number;
		try {
			this.state = 199;
			this._errHandler.sync(this);
			switch (this._input.LA(1)) {
			case ManimParser.STEP_INTO:
			case ManimParser.STEP_OVER:
				_localctx = new CodeTrackingAnnotationContext(_localctx);
				this.enterOuterAlt(_localctx, 1);
				{
				this.state = 168;
				(_localctx as CodeTrackingAnnotationContext)._step = this._input.LT(1);
				_la = this._input.LA(1);
				if (!(_la === ManimParser.STEP_INTO || _la === ManimParser.STEP_OVER)) {
					(_localctx as CodeTrackingAnnotationContext)._step = this._errHandler.recoverInline(this);
				} else {
					if (this._input.LA(1) === Token.EOF) {
						this.matchedEOF = true;
					}

					this._errHandler.reportMatch(this);
					this.consume();
				}
				this.state = 173;
				this._errHandler.sync(this);
				_la = this._input.LA(1);
				if (_la === ManimParser.OPEN_PARENTHESIS) {
					{
					this.state = 169;
					this.match(ManimParser.OPEN_PARENTHESIS);
					this.state = 170;
					(_localctx as CodeTrackingAnnotationContext)._condition = this.expr(0);
					this.state = 171;
					this.match(ManimParser.CLOSE_PARENTHESIS);
					}
				}

				this.state = 175;
				this.match(ManimParser.OPEN_CURLY_BRACKET);
				this.state = 176;
				this.stat(0);
				this.state = 177;
				this.match(ManimParser.CLOSE_CURLY_BRACKET);
				}
				break;
			case ManimParser.SPEED:
				_localctx = new AnimationSpeedUpAnnotationContext(_localctx);
				this.enterOuterAlt(_localctx, 2);
				{
				this.state = 179;
				this.match(ManimParser.SPEED);
				this.state = 184;
				this._errHandler.sync(this);
				_la = this._input.LA(1);
				if (_la === ManimParser.OPEN_PARENTHESIS) {
					{
					this.state = 180;
					this.match(ManimParser.OPEN_PARENTHESIS);
					this.state = 181;
					this.arg_list();
					this.state = 182;
					this.match(ManimParser.CLOSE_PARENTHESIS);
					}
				}

				this.state = 186;
				this.match(ManimParser.OPEN_CURLY_BRACKET);
				this.state = 187;
				this.stat(0);
				this.state = 188;
				this.match(ManimParser.CLOSE_CURLY_BRACKET);
				}
				break;
			case ManimParser.SUBTITLE:
			case ManimParser.SUBTITLE_ONCE:
				_localctx = new SubtitleAnnotationContext(_localctx);
				this.enterOuterAlt(_localctx, 3);
				{
				this.state = 190;
				(_localctx as SubtitleAnnotationContext)._show = this._input.LT(1);
				_la = this._input.LA(1);
				if (!(_la === ManimParser.SUBTITLE || _la === ManimParser.SUBTITLE_ONCE)) {
					(_localctx as SubtitleAnnotationContext)._show = this._errHandler.recoverInline(this);
				} else {
					if (this._input.LA(1) === Token.EOF) {
						this.matchedEOF = true;
					}

					this._errHandler.reportMatch(this);
					this.consume();
				}
				this.state = 191;
				this.match(ManimParser.OPEN_PARENTHESIS);
				this.state = 192;
				(_localctx as SubtitleAnnotationContext)._subtitle_text = this.expr(0);
				this.state = 195;
				this._errHandler.sync(this);
				_la = this._input.LA(1);
				if (_la === ManimParser.COMMA) {
					{
					this.state = 193;
					this.match(ManimParser.COMMA);
					this.state = 194;
					this.arg_list();
					}
				}

				this.state = 197;
				this.match(ManimParser.CLOSE_PARENTHESIS);
				}
				break;
			default:
				throw new NoViableAltException(this);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				_localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return _localctx;
	}
	// @RuleVersion(0)
	public forHeader(): ForHeaderContext {
		let _localctx: ForHeaderContext = new ForHeaderContext(this._ctx, this.state);
		this.enterRule(_localctx, 12, ManimParser.RULE_forHeader);
		let _la: number;
		try {
			_localctx = new RangeHeaderContext(_localctx);
			this.enterOuterAlt(_localctx, 1);
			{
			this.state = 201;
			this.match(ManimParser.IDENT);
			this.state = 202;
			this.match(ManimParser.IN);
			this.state = 203;
			this.match(ManimParser.RANGE);
			this.state = 204;
			this.match(ManimParser.OPEN_PARENTHESIS);
			this.state = 208;
			this._errHandler.sync(this);
			switch ( this.interpreter.adaptivePredict(this._input, 19, this._ctx) ) {
			case 1:
				{
				this.state = 205;
				(_localctx as RangeHeaderContext)._begin = this.expr(0);
				this.state = 206;
				this.match(ManimParser.COMMA);
				}
				break;
			}
			this.state = 210;
			(_localctx as RangeHeaderContext)._end = this.expr(0);
			this.state = 213;
			this._errHandler.sync(this);
			_la = this._input.LA(1);
			if (_la === ManimParser.COMMA) {
				{
				this.state = 211;
				this.match(ManimParser.COMMA);
				this.state = 212;
				(_localctx as RangeHeaderContext)._delta = this.expr(0);
				}
			}

			this.state = 215;
			this.match(ManimParser.CLOSE_PARENTHESIS);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				_localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return _localctx;
	}
	// @RuleVersion(0)
	public loop_stat(): Loop_statContext {
		let _localctx: Loop_statContext = new Loop_statContext(this._ctx, this.state);
		this.enterRule(_localctx, 14, ManimParser.RULE_loop_stat);
		try {
			this.state = 221;
			this._errHandler.sync(this);
			switch (this._input.LA(1)) {
			case ManimParser.BREAK:
				_localctx = new BreakStatementContext(_localctx);
				this.enterOuterAlt(_localctx, 1);
				{
				this.state = 217;
				this.match(ManimParser.BREAK);
				this.state = 218;
				this.match(ManimParser.SEMI);
				}
				break;
			case ManimParser.CONTINUE:
				_localctx = new ContinueStatementContext(_localctx);
				this.enterOuterAlt(_localctx, 2);
				{
				this.state = 219;
				this.match(ManimParser.CONTINUE);
				this.state = 220;
				this.match(ManimParser.SEMI);
				}
				break;
			default:
				throw new NoViableAltException(this);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				_localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return _localctx;
	}
	// @RuleVersion(0)
	public assignment_lhs(): Assignment_lhsContext {
		let _localctx: Assignment_lhsContext = new Assignment_lhsContext(this._ctx, this.state);
		this.enterRule(_localctx, 16, ManimParser.RULE_assignment_lhs);
		try {
			this.state = 226;
			this._errHandler.sync(this);
			switch ( this.interpreter.adaptivePredict(this._input, 22, this._ctx) ) {
			case 1:
				_localctx = new IdentifierAssignmentContext(_localctx);
				this.enterOuterAlt(_localctx, 1);
				{
				this.state = 223;
				this.match(ManimParser.IDENT);
				}
				break;

			case 2:
				_localctx = new ArrayElemAssignmentContext(_localctx);
				this.enterOuterAlt(_localctx, 2);
				{
				this.state = 224;
				this.array_elem();
				}
				break;

			case 3:
				_localctx = new NodeElemAssignmentContext(_localctx);
				this.enterOuterAlt(_localctx, 3);
				{
				this.state = 225;
				this.node_elem();
				}
				break;
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				_localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return _localctx;
	}
	// @RuleVersion(0)
	public elseIf(): ElseIfContext {
		let _localctx: ElseIfContext = new ElseIfContext(this._ctx, this.state);
		this.enterRule(_localctx, 18, ManimParser.RULE_elseIf);
		let _la: number;
		try {
			this.enterOuterAlt(_localctx, 1);
			{
			this.state = 228;
			this.match(ManimParser.ELSE);
			this.state = 229;
			this.match(ManimParser.IF);
			this.state = 230;
			this.match(ManimParser.OPEN_PARENTHESIS);
			this.state = 231;
			_localctx._elifCond = this.expr(0);
			this.state = 232;
			this.match(ManimParser.CLOSE_PARENTHESIS);
			this.state = 233;
			this.match(ManimParser.OPEN_CURLY_BRACKET);
			this.state = 235;
			this._errHandler.sync(this);
			_la = this._input.LA(1);
			if (((((_la - 30)) & ~0x1F) === 0 && ((1 << (_la - 30)) & ((1 << (ManimParser.LET - 30)) | (1 << (ManimParser.RETURN - 30)) | (1 << (ManimParser.SLEEP - 30)) | (1 << (ManimParser.IF - 30)) | (1 << (ManimParser.WHILE - 30)) | (1 << (ManimParser.FOR - 30)) | (1 << (ManimParser.BREAK - 30)) | (1 << (ManimParser.CONTINUE - 30)) | (1 << (ManimParser.STEP_INTO - 30)) | (1 << (ManimParser.STEP_OVER - 30)) | (1 << (ManimParser.SPEED - 30)) | (1 << (ManimParser.SUBTITLE - 30)) | (1 << (ManimParser.SUBTITLE_ONCE - 30)) | (1 << (ManimParser.IDENT - 30)))) !== 0)) {
				{
				this.state = 234;
				_localctx._elifStat = this.stat(0);
				}
			}

			this.state = 237;
			this.match(ManimParser.CLOSE_CURLY_BRACKET);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				_localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return _localctx;
	}
	// @RuleVersion(0)
	public arg_list(): Arg_listContext {
		let _localctx: Arg_listContext = new Arg_listContext(this._ctx, this.state);
		this.enterRule(_localctx, 20, ManimParser.RULE_arg_list);
		let _la: number;
		try {
			_localctx = new ArgumentListContext(_localctx);
			this.enterOuterAlt(_localctx, 1);
			{
			this.state = 239;
			this.expr(0);
			this.state = 244;
			this._errHandler.sync(this);
			_la = this._input.LA(1);
			while (_la === ManimParser.COMMA) {
				{
				{
				this.state = 240;
				this.match(ManimParser.COMMA);
				this.state = 241;
				this.expr(0);
				}
				}
				this.state = 246;
				this._errHandler.sync(this);
				_la = this._input.LA(1);
			}
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				_localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return _localctx;
	}

	public expr(): ExprContext;
	public expr(_p: number): ExprContext;
	// @RuleVersion(0)
	public expr(_p?: number): ExprContext {
		if (_p === undefined) {
			_p = 0;
		}

		let _parentctx: ParserRuleContext = this._ctx;
		let _parentState: number = this.state;
		let _localctx: ExprContext = new ExprContext(this._ctx, _parentState);
		let _prevctx: ExprContext = _localctx;
		let _startState: number = 22;
		this.enterRecursionRule(_localctx, 22, ManimParser.RULE_expr, _p);
		let _la: number;
		try {
			let _alt: number;
			this.enterOuterAlt(_localctx, 1);
			{
			this.state = 277;
			this._errHandler.sync(this);
			switch ( this.interpreter.adaptivePredict(this._input, 27, this._ctx) ) {
			case 1:
				{
				_localctx = new NumberLiteralContext(_localctx);
				this._ctx = _localctx;
				_prevctx = _localctx;

				this.state = 248;
				this.match(ManimParser.NUMBER);
				}
				break;

			case 2:
				{
				_localctx = new StringLiteralContext(_localctx);
				this._ctx = _localctx;
				_prevctx = _localctx;
				this.state = 249;
				this.match(ManimParser.STRING);
				}
				break;

			case 3:
				{
				_localctx = new NullLiteralContext(_localctx);
				this._ctx = _localctx;
				_prevctx = _localctx;
				this.state = 250;
				this.match(ManimParser.NULL);
				}
				break;

			case 4:
				{
				_localctx = new BooleanLiteralContext(_localctx);
				this._ctx = _localctx;
				_prevctx = _localctx;
				this.state = 251;
				this.bool();
				}
				break;

			case 5:
				{
				_localctx = new CharacterLiteralContext(_localctx);
				this._ctx = _localctx;
				_prevctx = _localctx;
				this.state = 252;
				this.match(ManimParser.CHAR_LITER);
				}
				break;

			case 6:
				{
				_localctx = new IdentifierContext(_localctx);
				this._ctx = _localctx;
				_prevctx = _localctx;
				this.state = 253;
				this.match(ManimParser.IDENT);
				}
				break;

			case 7:
				{
				_localctx = new ArrayElemExprContext(_localctx);
				this._ctx = _localctx;
				_prevctx = _localctx;
				this.state = 254;
				this.array_elem();
				}
				break;

			case 8:
				{
				_localctx = new NodeElemExprContext(_localctx);
				this._ctx = _localctx;
				_prevctx = _localctx;
				this.state = 255;
				this.node_elem();
				}
				break;

			case 9:
				{
				_localctx = new DataStructureConstructorContext(_localctx);
				this._ctx = _localctx;
				_prevctx = _localctx;
				this.state = 256;
				this.data_structure_type();
				this.state = 257;
				this.match(ManimParser.OPEN_PARENTHESIS);
				this.state = 259;
				this._errHandler.sync(this);
				_la = this._input.LA(1);
				if ((((_la) & ~0x1F) === 0 && ((1 << _la) & ((1 << ManimParser.TRUE) | (1 << ManimParser.FALSE) | (1 << ManimParser.ADD) | (1 << ManimParser.MINUS) | (1 << ManimParser.NOT) | (1 << ManimParser.OPEN_PARENTHESIS))) !== 0) || ((((_la - 39)) & ~0x1F) === 0 && ((1 << (_la - 39)) & ((1 << (ManimParser.STACK - 39)) | (1 << (ManimParser.ARRAY - 39)) | (1 << (ManimParser.LIST - 39)) | (1 << (ManimParser.TREE - 39)) | (1 << (ManimParser.TREE_NODE - 39)) | (1 << (ManimParser.TO_NUMBER - 39)) | (1 << (ManimParser.TO_CHAR - 39)) | (1 << (ManimParser.NULL - 39)) | (1 << (ManimParser.IDENT - 39)) | (1 << (ManimParser.NUMBER - 39)) | (1 << (ManimParser.STRING - 39)) | (1 << (ManimParser.CHAR_LITER - 39)))) !== 0)) {
					{
					this.state = 258;
					this.arg_list();
					}
				}

				this.state = 261;
				this.match(ManimParser.CLOSE_PARENTHESIS);
				this.state = 263;
				this._errHandler.sync(this);
				switch ( this.interpreter.adaptivePredict(this._input, 26, this._ctx) ) {
				case 1:
					{
					this.state = 262;
					this.data_structure_initialiser();
					}
					break;
				}
				}
				break;

			case 10:
				{
				_localctx = new MethodCallExpressionContext(_localctx);
				this._ctx = _localctx;
				_prevctx = _localctx;
				this.state = 265;
				this.method_call();
				}
				break;

			case 11:
				{
				_localctx = new UnaryOperatorContext(_localctx);
				this._ctx = _localctx;
				_prevctx = _localctx;
				this.state = 266;
				(_localctx as UnaryOperatorContext)._unary_operator = this._input.LT(1);
				_la = this._input.LA(1);
				if (!((((_la) & ~0x1F) === 0 && ((1 << _la) & ((1 << ManimParser.ADD) | (1 << ManimParser.MINUS) | (1 << ManimParser.NOT))) !== 0))) {
					(_localctx as UnaryOperatorContext)._unary_operator = this._errHandler.recoverInline(this);
				} else {
					if (this._input.LA(1) === Token.EOF) {
						this.matchedEOF = true;
					}

					this._errHandler.reportMatch(this);
					this.consume();
				}
				this.state = 267;
				this.expr(7);
				}
				break;

			case 12:
				{
				_localctx = new CastExpressionContext(_localctx);
				this._ctx = _localctx;
				_prevctx = _localctx;
				this.state = 268;
				this.cast_method();
				this.state = 269;
				this.match(ManimParser.OPEN_PARENTHESIS);
				this.state = 270;
				this.expr(0);
				this.state = 271;
				this.match(ManimParser.CLOSE_PARENTHESIS);
				}
				break;

			case 13:
				{
				_localctx = new BracketedExpressionContext(_localctx);
				this._ctx = _localctx;
				_prevctx = _localctx;
				this.state = 273;
				this.match(ManimParser.OPEN_PARENTHESIS);
				this.state = 274;
				this.expr(0);
				this.state = 275;
				this.match(ManimParser.CLOSE_PARENTHESIS);
				}
				break;
			}
			this._ctx._stop = this._input.tryLT(-1);
			this.state = 293;
			this._errHandler.sync(this);
			_alt = this.interpreter.adaptivePredict(this._input, 29, this._ctx);
			while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
				if (_alt === 1) {
					if (this._parseListeners != null) {
						this.triggerExitRuleEvent();
					}
					_prevctx = _localctx;
					{
					this.state = 291;
					this._errHandler.sync(this);
					switch ( this.interpreter.adaptivePredict(this._input, 28, this._ctx) ) {
					case 1:
						{
						_localctx = new BinaryExpressionContext(new ExprContext(_parentctx, _parentState));
						(_localctx as BinaryExpressionContext)._left = _prevctx;
						this.pushNewRecursionContext(_localctx, _startState, ManimParser.RULE_expr);
						this.state = 279;
						if (!(this.precpred(this._ctx, 6))) {
							throw new FailedPredicateException(this, "this.precpred(this._ctx, 6)");
						}
						this.state = 280;
						(_localctx as BinaryExpressionContext)._binary_operator = this._input.LT(1);
						_la = this._input.LA(1);
						if (!((((_la) & ~0x1F) === 0 && ((1 << _la) & ((1 << ManimParser.ADD) | (1 << ManimParser.MINUS) | (1 << ManimParser.TIMES) | (1 << ManimParser.DIVIDE))) !== 0))) {
							(_localctx as BinaryExpressionContext)._binary_operator = this._errHandler.recoverInline(this);
						} else {
							if (this._input.LA(1) === Token.EOF) {
								this.matchedEOF = true;
							}

							this._errHandler.reportMatch(this);
							this.consume();
						}
						this.state = 281;
						(_localctx as BinaryExpressionContext)._right = this.expr(7);
						}
						break;

					case 2:
						{
						_localctx = new BinaryExpressionContext(new ExprContext(_parentctx, _parentState));
						(_localctx as BinaryExpressionContext)._left = _prevctx;
						this.pushNewRecursionContext(_localctx, _startState, ManimParser.RULE_expr);
						this.state = 282;
						if (!(this.precpred(this._ctx, 5))) {
							throw new FailedPredicateException(this, "this.precpred(this._ctx, 5)");
						}
						this.state = 283;
						(_localctx as BinaryExpressionContext)._binary_operator = this._input.LT(1);
						_la = this._input.LA(1);
						if (!((((_la) & ~0x1F) === 0 && ((1 << _la) & ((1 << ManimParser.LT) | (1 << ManimParser.GT) | (1 << ManimParser.GE) | (1 << ManimParser.LE))) !== 0))) {
							(_localctx as BinaryExpressionContext)._binary_operator = this._errHandler.recoverInline(this);
						} else {
							if (this._input.LA(1) === Token.EOF) {
								this.matchedEOF = true;
							}

							this._errHandler.reportMatch(this);
							this.consume();
						}
						this.state = 284;
						(_localctx as BinaryExpressionContext)._right = this.expr(6);
						}
						break;

					case 3:
						{
						_localctx = new BinaryExpressionContext(new ExprContext(_parentctx, _parentState));
						(_localctx as BinaryExpressionContext)._left = _prevctx;
						this.pushNewRecursionContext(_localctx, _startState, ManimParser.RULE_expr);
						this.state = 285;
						if (!(this.precpred(this._ctx, 4))) {
							throw new FailedPredicateException(this, "this.precpred(this._ctx, 4)");
						}
						this.state = 286;
						(_localctx as BinaryExpressionContext)._binary_operator = this._input.LT(1);
						_la = this._input.LA(1);
						if (!(_la === ManimParser.EQ || _la === ManimParser.NEQ)) {
							(_localctx as BinaryExpressionContext)._binary_operator = this._errHandler.recoverInline(this);
						} else {
							if (this._input.LA(1) === Token.EOF) {
								this.matchedEOF = true;
							}

							this._errHandler.reportMatch(this);
							this.consume();
						}
						this.state = 287;
						(_localctx as BinaryExpressionContext)._right = this.expr(5);
						}
						break;

					case 4:
						{
						_localctx = new BinaryExpressionContext(new ExprContext(_parentctx, _parentState));
						(_localctx as BinaryExpressionContext)._left = _prevctx;
						this.pushNewRecursionContext(_localctx, _startState, ManimParser.RULE_expr);
						this.state = 288;
						if (!(this.precpred(this._ctx, 3))) {
							throw new FailedPredicateException(this, "this.precpred(this._ctx, 3)");
						}
						this.state = 289;
						(_localctx as BinaryExpressionContext)._binary_operator = this._input.LT(1);
						_la = this._input.LA(1);
						if (!(_la === ManimParser.AND || _la === ManimParser.OR)) {
							(_localctx as BinaryExpressionContext)._binary_operator = this._errHandler.recoverInline(this);
						} else {
							if (this._input.LA(1) === Token.EOF) {
								this.matchedEOF = true;
							}

							this._errHandler.reportMatch(this);
							this.consume();
						}
						this.state = 290;
						(_localctx as BinaryExpressionContext)._right = this.expr(4);
						}
						break;
					}
					}
				}
				this.state = 295;
				this._errHandler.sync(this);
				_alt = this.interpreter.adaptivePredict(this._input, 29, this._ctx);
			}
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				_localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.unrollRecursionContexts(_parentctx);
		}
		return _localctx;
	}
	// @RuleVersion(0)
	public cast_method(): Cast_methodContext {
		let _localctx: Cast_methodContext = new Cast_methodContext(this._ctx, this.state);
		this.enterRule(_localctx, 24, ManimParser.RULE_cast_method);
		try {
			this.state = 298;
			this._errHandler.sync(this);
			switch (this._input.LA(1)) {
			case ManimParser.TO_NUMBER:
				_localctx = new ToNumberContext(_localctx);
				this.enterOuterAlt(_localctx, 1);
				{
				this.state = 296;
				this.match(ManimParser.TO_NUMBER);
				}
				break;
			case ManimParser.TO_CHAR:
				_localctx = new ToCharacterContext(_localctx);
				this.enterOuterAlt(_localctx, 2);
				{
				this.state = 297;
				this.match(ManimParser.TO_CHAR);
				}
				break;
			default:
				throw new NoViableAltException(this);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				_localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return _localctx;
	}
	// @RuleVersion(0)
	public method_call(): Method_callContext {
		let _localctx: Method_callContext = new Method_callContext(this._ctx, this.state);
		this.enterRule(_localctx, 26, ManimParser.RULE_method_call);
		let _la: number;
		try {
			this.state = 320;
			this._errHandler.sync(this);
			switch ( this.interpreter.adaptivePredict(this._input, 34, this._ctx) ) {
			case 1:
				_localctx = new MethodCallContext(_localctx);
				this.enterOuterAlt(_localctx, 1);
				{
				this.state = 300;
				this.match(ManimParser.IDENT);
				this.state = 305;
				this._errHandler.sync(this);
				_la = this._input.LA(1);
				if (_la === ManimParser.OPEN_SQUARE_BRACKET) {
					{
					this.state = 301;
					this.match(ManimParser.OPEN_SQUARE_BRACKET);
					this.state = 302;
					this.expr(0);
					this.state = 303;
					this.match(ManimParser.CLOSE_SQUARE_BRACKET);
					}
				}

				this.state = 307;
				this.match(ManimParser.DOT);
				this.state = 308;
				this.match(ManimParser.IDENT);
				this.state = 309;
				this.match(ManimParser.OPEN_PARENTHESIS);
				this.state = 311;
				this._errHandler.sync(this);
				_la = this._input.LA(1);
				if ((((_la) & ~0x1F) === 0 && ((1 << _la) & ((1 << ManimParser.TRUE) | (1 << ManimParser.FALSE) | (1 << ManimParser.ADD) | (1 << ManimParser.MINUS) | (1 << ManimParser.NOT) | (1 << ManimParser.OPEN_PARENTHESIS))) !== 0) || ((((_la - 39)) & ~0x1F) === 0 && ((1 << (_la - 39)) & ((1 << (ManimParser.STACK - 39)) | (1 << (ManimParser.ARRAY - 39)) | (1 << (ManimParser.LIST - 39)) | (1 << (ManimParser.TREE - 39)) | (1 << (ManimParser.TREE_NODE - 39)) | (1 << (ManimParser.TO_NUMBER - 39)) | (1 << (ManimParser.TO_CHAR - 39)) | (1 << (ManimParser.NULL - 39)) | (1 << (ManimParser.IDENT - 39)) | (1 << (ManimParser.NUMBER - 39)) | (1 << (ManimParser.STRING - 39)) | (1 << (ManimParser.CHAR_LITER - 39)))) !== 0)) {
					{
					this.state = 310;
					this.arg_list();
					}
				}

				this.state = 313;
				this.match(ManimParser.CLOSE_PARENTHESIS);
				}
				break;

			case 2:
				_localctx = new FunctionCallContext(_localctx);
				this.enterOuterAlt(_localctx, 2);
				{
				this.state = 314;
				this.match(ManimParser.IDENT);
				this.state = 315;
				this.match(ManimParser.OPEN_PARENTHESIS);
				this.state = 317;
				this._errHandler.sync(this);
				_la = this._input.LA(1);
				if ((((_la) & ~0x1F) === 0 && ((1 << _la) & ((1 << ManimParser.TRUE) | (1 << ManimParser.FALSE) | (1 << ManimParser.ADD) | (1 << ManimParser.MINUS) | (1 << ManimParser.NOT) | (1 << ManimParser.OPEN_PARENTHESIS))) !== 0) || ((((_la - 39)) & ~0x1F) === 0 && ((1 << (_la - 39)) & ((1 << (ManimParser.STACK - 39)) | (1 << (ManimParser.ARRAY - 39)) | (1 << (ManimParser.LIST - 39)) | (1 << (ManimParser.TREE - 39)) | (1 << (ManimParser.TREE_NODE - 39)) | (1 << (ManimParser.TO_NUMBER - 39)) | (1 << (ManimParser.TO_CHAR - 39)) | (1 << (ManimParser.NULL - 39)) | (1 << (ManimParser.IDENT - 39)) | (1 << (ManimParser.NUMBER - 39)) | (1 << (ManimParser.STRING - 39)) | (1 << (ManimParser.CHAR_LITER - 39)))) !== 0)) {
					{
					this.state = 316;
					this.arg_list();
					}
				}

				this.state = 319;
				this.match(ManimParser.CLOSE_PARENTHESIS);
				}
				break;
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				_localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return _localctx;
	}
	// @RuleVersion(0)
	public type(): TypeContext {
		let _localctx: TypeContext = new TypeContext(this._ctx, this.state);
		this.enterRule(_localctx, 28, ManimParser.RULE_type);
		try {
			this.state = 324;
			this._errHandler.sync(this);
			switch (this._input.LA(1)) {
			case ManimParser.STACK:
			case ManimParser.ARRAY:
			case ManimParser.LIST:
			case ManimParser.TREE:
			case ManimParser.TREE_NODE:
				_localctx = new DataStructureTypeContext(_localctx);
				this.enterOuterAlt(_localctx, 1);
				{
				this.state = 322;
				this.data_structure_type();
				}
				break;
			case ManimParser.NUMBER_TYPE:
			case ManimParser.BOOL_TYPE:
			case ManimParser.CHAR_TYPE:
			case ManimParser.STRING_TYPE:
				_localctx = new PrimitiveTypeContext(_localctx);
				this.enterOuterAlt(_localctx, 2);
				{
				this.state = 323;
				this.primitive_type();
				}
				break;
			default:
				throw new NoViableAltException(this);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				_localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return _localctx;
	}
	// @RuleVersion(0)
	public node_type(): Node_typeContext {
		let _localctx: Node_typeContext = new Node_typeContext(this._ctx, this.state);
		this.enterRule(_localctx, 30, ManimParser.RULE_node_type);
		try {
			this.enterOuterAlt(_localctx, 1);
			{
			this.state = 326;
			this.match(ManimParser.TREE_NODE);
			this.state = 327;
			this.match(ManimParser.LT);
			this.state = 328;
			this.primitive_type();
			this.state = 329;
			this.match(ManimParser.GT);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				_localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return _localctx;
	}
	// @RuleVersion(0)
	public data_structure_type(): Data_structure_typeContext {
		let _localctx: Data_structure_typeContext = new Data_structure_typeContext(this._ctx, this.state);
		this.enterRule(_localctx, 32, ManimParser.RULE_data_structure_type);
		try {
			let _alt: number;
			this.state = 359;
			this._errHandler.sync(this);
			switch (this._input.LA(1)) {
			case ManimParser.STACK:
				_localctx = new StackTypeContext(_localctx);
				this.enterOuterAlt(_localctx, 1);
				{
				this.state = 331;
				this.match(ManimParser.STACK);
				this.state = 332;
				this.match(ManimParser.LT);
				this.state = 333;
				this.primitive_type();
				this.state = 334;
				this.match(ManimParser.GT);
				}
				break;
			case ManimParser.ARRAY:
				_localctx = new ArrayTypeContext(_localctx);
				this.enterOuterAlt(_localctx, 2);
				{
				this.state = 338;
				this._errHandler.sync(this);
				_alt = 1;
				do {
					switch (_alt) {
					case 1:
						{
						{
						this.state = 336;
						this.match(ManimParser.ARRAY);
						this.state = 337;
						this.match(ManimParser.LT);
						}
						}
						break;
					default:
						throw new NoViableAltException(this);
					}
					this.state = 340;
					this._errHandler.sync(this);
					_alt = this.interpreter.adaptivePredict(this._input, 36, this._ctx);
				} while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER);
				this.state = 342;
				this.type();
				this.state = 344;
				this._errHandler.sync(this);
				_alt = 1;
				do {
					switch (_alt) {
					case 1:
						{
						{
						this.state = 343;
						this.match(ManimParser.GT);
						}
						}
						break;
					default:
						throw new NoViableAltException(this);
					}
					this.state = 346;
					this._errHandler.sync(this);
					_alt = this.interpreter.adaptivePredict(this._input, 37, this._ctx);
				} while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER);
				}
				break;
			case ManimParser.LIST:
				_localctx = new ListTypeContext(_localctx);
				this.enterOuterAlt(_localctx, 3);
				{
				this.state = 348;
				this.match(ManimParser.LIST);
				this.state = 349;
				this.match(ManimParser.LT);
				this.state = 350;
				this.type();
				this.state = 351;
				this.match(ManimParser.GT);
				}
				break;
			case ManimParser.TREE_NODE:
				_localctx = new NodeTypeContext(_localctx);
				this.enterOuterAlt(_localctx, 4);
				{
				this.state = 353;
				this.node_type();
				}
				break;
			case ManimParser.TREE:
				_localctx = new TreeTypeContext(_localctx);
				this.enterOuterAlt(_localctx, 5);
				{
				this.state = 354;
				this.match(ManimParser.TREE);
				this.state = 355;
				this.match(ManimParser.LT);
				this.state = 356;
				this.node_type();
				this.state = 357;
				this.match(ManimParser.GT);
				}
				break;
			default:
				throw new NoViableAltException(this);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				_localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return _localctx;
	}
	// @RuleVersion(0)
	public primitive_type(): Primitive_typeContext {
		let _localctx: Primitive_typeContext = new Primitive_typeContext(this._ctx, this.state);
		this.enterRule(_localctx, 34, ManimParser.RULE_primitive_type);
		try {
			this.state = 365;
			this._errHandler.sync(this);
			switch (this._input.LA(1)) {
			case ManimParser.NUMBER_TYPE:
				_localctx = new NumberTypeContext(_localctx);
				this.enterOuterAlt(_localctx, 1);
				{
				this.state = 361;
				this.match(ManimParser.NUMBER_TYPE);
				}
				break;
			case ManimParser.BOOL_TYPE:
				_localctx = new BoolTypeContext(_localctx);
				this.enterOuterAlt(_localctx, 2);
				{
				this.state = 362;
				this.match(ManimParser.BOOL_TYPE);
				}
				break;
			case ManimParser.CHAR_TYPE:
				_localctx = new CharTypeContext(_localctx);
				this.enterOuterAlt(_localctx, 3);
				{
				this.state = 363;
				this.match(ManimParser.CHAR_TYPE);
				}
				break;
			case ManimParser.STRING_TYPE:
				_localctx = new StringTypeContext(_localctx);
				this.enterOuterAlt(_localctx, 4);
				{
				this.state = 364;
				this.match(ManimParser.STRING_TYPE);
				}
				break;
			default:
				throw new NoViableAltException(this);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				_localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return _localctx;
	}
	// @RuleVersion(0)
	public bool(): BoolContext {
		let _localctx: BoolContext = new BoolContext(this._ctx, this.state);
		this.enterRule(_localctx, 36, ManimParser.RULE_bool);
		let _la: number;
		try {
			this.enterOuterAlt(_localctx, 1);
			{
			this.state = 367;
			_la = this._input.LA(1);
			if (!(_la === ManimParser.TRUE || _la === ManimParser.FALSE)) {
			this._errHandler.recoverInline(this);
			} else {
				if (this._input.LA(1) === Token.EOF) {
					this.matchedEOF = true;
				}

				this._errHandler.reportMatch(this);
				this.consume();
			}
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				_localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return _localctx;
	}
	// @RuleVersion(0)
	public data_structure_initialiser(): Data_structure_initialiserContext {
		let _localctx: Data_structure_initialiserContext = new Data_structure_initialiserContext(this._ctx, this.state);
		this.enterRule(_localctx, 38, ManimParser.RULE_data_structure_initialiser);
		try {
			this.enterOuterAlt(_localctx, 1);
			{
			this.state = 369;
			this.match(ManimParser.OPEN_CURLY_BRACKET);
			this.state = 372;
			this._errHandler.sync(this);
			switch (this._input.LA(1)) {
			case ManimParser.TRUE:
			case ManimParser.FALSE:
			case ManimParser.ADD:
			case ManimParser.MINUS:
			case ManimParser.NOT:
			case ManimParser.OPEN_PARENTHESIS:
			case ManimParser.STACK:
			case ManimParser.ARRAY:
			case ManimParser.LIST:
			case ManimParser.TREE:
			case ManimParser.TREE_NODE:
			case ManimParser.TO_NUMBER:
			case ManimParser.TO_CHAR:
			case ManimParser.NULL:
			case ManimParser.IDENT:
			case ManimParser.NUMBER:
			case ManimParser.STRING:
			case ManimParser.CHAR_LITER:
				{
				this.state = 370;
				this.arg_list();
				}
				break;
			case ManimParser.OPEN_SQUARE_BRACKET:
				{
				this.state = 371;
				this.initialiser_list();
				}
				break;
			default:
				throw new NoViableAltException(this);
			}
			this.state = 374;
			this.match(ManimParser.CLOSE_CURLY_BRACKET);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				_localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return _localctx;
	}
	// @RuleVersion(0)
	public initialiser_list(): Initialiser_listContext {
		let _localctx: Initialiser_listContext = new Initialiser_listContext(this._ctx, this.state);
		this.enterRule(_localctx, 40, ManimParser.RULE_initialiser_list);
		let _la: number;
		try {
			this.enterOuterAlt(_localctx, 1);
			{
			this.state = 376;
			this.match(ManimParser.OPEN_SQUARE_BRACKET);
			this.state = 377;
			this.arg_list();
			this.state = 378;
			this.match(ManimParser.CLOSE_SQUARE_BRACKET);
			this.state = 386;
			this._errHandler.sync(this);
			_la = this._input.LA(1);
			while (_la === ManimParser.COMMA) {
				{
				{
				this.state = 379;
				this.match(ManimParser.COMMA);
				this.state = 380;
				this.match(ManimParser.OPEN_SQUARE_BRACKET);
				this.state = 381;
				this.arg_list();
				this.state = 382;
				this.match(ManimParser.CLOSE_SQUARE_BRACKET);
				}
				}
				this.state = 388;
				this._errHandler.sync(this);
				_la = this._input.LA(1);
			}
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				_localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return _localctx;
	}
	// @RuleVersion(0)
	public array_elem(): Array_elemContext {
		let _localctx: Array_elemContext = new Array_elemContext(this._ctx, this.state);
		this.enterRule(_localctx, 42, ManimParser.RULE_array_elem);
		try {
			let _alt: number;
			this.enterOuterAlt(_localctx, 1);
			{
			this.state = 389;
			this.match(ManimParser.IDENT);
			this.state = 394;
			this._errHandler.sync(this);
			_alt = 1;
			do {
				switch (_alt) {
				case 1:
					{
					{
					this.state = 390;
					this.match(ManimParser.OPEN_SQUARE_BRACKET);
					this.state = 391;
					this.expr(0);
					this.state = 392;
					this.match(ManimParser.CLOSE_SQUARE_BRACKET);
					}
					}
					break;
				default:
					throw new NoViableAltException(this);
				}
				this.state = 396;
				this._errHandler.sync(this);
				_alt = this.interpreter.adaptivePredict(this._input, 42, this._ctx);
			} while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				_localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return _localctx;
	}
	// @RuleVersion(0)
	public node_elem(): Node_elemContext {
		let _localctx: Node_elemContext = new Node_elemContext(this._ctx, this.state);
		this.enterRule(_localctx, 44, ManimParser.RULE_node_elem);
		try {
			let _alt: number;
			this.enterOuterAlt(_localctx, 1);
			{
			this.state = 398;
			this.match(ManimParser.IDENT);
			this.state = 402;
			this._errHandler.sync(this);
			_alt = this.interpreter.adaptivePredict(this._input, 43, this._ctx);
			while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
				if (_alt === 1) {
					{
					{
					this.state = 399;
					this.node_elem_access();
					}
					}
				}
				this.state = 404;
				this._errHandler.sync(this);
				_alt = this.interpreter.adaptivePredict(this._input, 43, this._ctx);
			}
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				_localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return _localctx;
	}
	// @RuleVersion(0)
	public node_elem_access(): Node_elem_accessContext {
		let _localctx: Node_elem_accessContext = new Node_elem_accessContext(this._ctx, this.state);
		this.enterRule(_localctx, 46, ManimParser.RULE_node_elem_access);
		try {
			this.enterOuterAlt(_localctx, 1);
			{
			{
			this.state = 405;
			this.match(ManimParser.DOT);
			this.state = 406;
			this.match(ManimParser.IDENT);
			}
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				_localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return _localctx;
	}

	public sempred(_localctx: RuleContext, ruleIndex: number, predIndex: number): boolean {
		switch (ruleIndex) {
		case 4:
			return this.stat_sempred(_localctx as StatContext, predIndex);

		case 11:
			return this.expr_sempred(_localctx as ExprContext, predIndex);
		}
		return true;
	}
	private stat_sempred(_localctx: StatContext, predIndex: number): boolean {
		switch (predIndex) {
		case 0:
			return this.precpred(this._ctx, 4);
		}
		return true;
	}
	private expr_sempred(_localctx: ExprContext, predIndex: number): boolean {
		switch (predIndex) {
		case 1:
			return this.precpred(this._ctx, 6);

		case 2:
			return this.precpred(this._ctx, 5);

		case 3:
			return this.precpred(this._ctx, 4);

		case 4:
			return this.precpred(this._ctx, 3);
		}
		return true;
	}

	public static readonly _serializedATN: string =
		"\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x03A\u019B\x04\x02" +
		"\t\x02\x04\x03\t\x03\x04\x04\t\x04\x04\x05\t\x05\x04\x06\t\x06\x04\x07" +
		"\t\x07\x04\b\t\b\x04\t\t\t\x04\n\t\n\x04\v\t\v\x04\f\t\f\x04\r\t\r\x04" +
		"\x0E\t\x0E\x04\x0F\t\x0F\x04\x10\t\x10\x04\x11\t\x11\x04\x12\t\x12\x04" +
		"\x13\t\x13\x04\x14\t\x14\x04\x15\t\x15\x04\x16\t\x16\x04\x17\t\x17\x04" +
		"\x18\t\x18\x04\x19\t\x19\x03\x02\x07\x024\n\x02\f\x02\x0E\x027\v\x02\x03" +
		"\x02\x03\x02\x03\x02\x03\x03\x03\x03\x03\x03\x03\x03\x05\x03@\n\x03\x03" +
		"\x03\x03\x03\x03\x03\x05\x03E\n\x03\x03\x03\x03\x03\x05\x03I\n\x03\x03" +
		"\x03\x03\x03\x03\x04\x03\x04\x03\x04\x07\x04P\n\x04\f\x04\x0E\x04S\v\x04" +
		"\x03\x05\x03\x05\x03\x05\x03\x05\x03\x06\x03\x06\x03\x06\x03\x06\x03\x06" +
		"\x03\x06\x03\x06\x03\x06\x03\x06\x03\x06\x03\x06\x05\x06d\n\x06\x03\x06" +
		"\x03\x06\x03\x06\x03\x06\x03\x06\x03\x06\x03\x06\x03\x06\x03\x06\x03\x06" +
		"\x03\x06\x03\x06\x03\x06\x03\x06\x03\x06\x05\x06u\n\x06\x03\x06\x03\x06" +
		"\x07\x06y\n\x06\f\x06\x0E\x06|\v\x06\x03\x06\x03\x06\x03\x06\x05\x06\x81" +
		"\n\x06\x03\x06\x05\x06\x84\n\x06\x03\x06\x03\x06\x03\x06\x03\x06\x03\x06" +
		"\x03\x06\x05\x06\x8C\n\x06\x03\x06\x03\x06\x03\x06\x03\x06\x03\x06\x03" +
		"\x06\x05\x06\x94\n\x06\x03\x06\x03\x06\x03\x06\x03\x06\x03\x06\x03\x06" +
		"\x03\x06\x03\x06\x05\x06\x9E\n\x06\x03\x06\x03\x06\x05\x06\xA2\n\x06\x03" +
		"\x06\x03\x06\x07\x06\xA6\n\x06\f\x06\x0E\x06\xA9\v\x06\x03\x07\x03\x07" +
		"\x03\x07\x03\x07\x03\x07\x05\x07\xB0\n\x07\x03\x07\x03\x07\x03\x07\x03" +
		"\x07\x03\x07\x03\x07\x03\x07\x03\x07\x03\x07\x05\x07\xBB\n\x07\x03\x07" +
		"\x03\x07\x03\x07\x03\x07\x03\x07\x03\x07\x03\x07\x03\x07\x03\x07\x05\x07" +
		"\xC6\n\x07\x03\x07\x03\x07\x05\x07\xCA\n\x07\x03\b\x03\b\x03\b\x03\b\x03" +
		"\b\x03\b\x03\b\x05\b\xD3\n\b\x03\b\x03\b\x03\b\x05\b\xD8\n\b\x03\b\x03" +
		"\b\x03\t\x03\t\x03\t\x03\t\x05\t\xE0\n\t\x03\n\x03\n\x03\n\x05\n\xE5\n" +
		"\n\x03\v\x03\v\x03\v\x03\v\x03\v\x03\v\x03\v\x05\v\xEE\n\v\x03\v\x03\v" +
		"\x03\f\x03\f\x03\f\x07\f\xF5\n\f\f\f\x0E\f\xF8\v\f\x03\r\x03\r\x03\r\x03" +
		"\r\x03\r\x03\r\x03\r\x03\r\x03\r\x03\r\x03\r\x03\r\x05\r\u0106\n\r\x03" +
		"\r\x03\r\x05\r\u010A\n\r\x03\r\x03\r\x03\r\x03\r\x03\r\x03\r\x03\r\x03" +
		"\r\x03\r\x03\r\x03\r\x03\r\x05\r\u0118\n\r\x03\r\x03\r\x03\r\x03\r\x03" +
		"\r\x03\r\x03\r\x03\r\x03\r\x03\r\x03\r\x03\r\x07\r\u0126\n\r\f\r\x0E\r" +
		"\u0129\v\r\x03\x0E\x03\x0E\x05\x0E\u012D\n\x0E\x03\x0F\x03\x0F\x03\x0F" +
		"\x03\x0F\x03\x0F\x05\x0F\u0134\n\x0F\x03\x0F\x03\x0F\x03\x0F\x03\x0F\x05" +
		"\x0F\u013A\n\x0F\x03\x0F\x03\x0F\x03\x0F\x03\x0F\x05\x0F\u0140\n\x0F\x03" +
		"\x0F\x05\x0F\u0143\n\x0F\x03\x10\x03\x10\x05\x10\u0147\n\x10\x03\x11\x03" +
		"\x11\x03\x11\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x03\x12\x03\x12\x03" +
		"\x12\x03\x12\x06\x12\u0155\n\x12\r\x12\x0E\x12\u0156\x03\x12\x03\x12\x06" +
		"\x12\u015B\n\x12\r\x12\x0E\x12\u015C\x03\x12\x03\x12\x03\x12\x03\x12\x03" +
		"\x12\x03\x12\x03\x12\x03\x12\x03\x12\x03\x12\x03\x12\x05\x12\u016A\n\x12" +
		"\x03\x13\x03\x13\x03\x13\x03\x13\x05\x13\u0170\n\x13\x03\x14\x03\x14\x03" +
		"\x15\x03\x15\x03\x15\x05\x15\u0177\n\x15\x03\x15\x03\x15\x03\x16\x03\x16" +
		"\x03\x16\x03\x16\x03\x16\x03\x16\x03\x16\x03\x16\x07\x16\u0183\n\x16\f" +
		"\x16\x0E\x16\u0186\v\x16\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x06\x17" +
		"\u018D\n\x17\r\x17\x0E\x17\u018E\x03\x18\x03\x18\x07\x18\u0193\n\x18\f" +
		"\x18\x0E\x18\u0196\v\x18\x03\x19\x03\x19\x03\x19\x03\x19\x02\x02\x04\n" +
		"\x18\x1A\x02\x02\x04\x02\x06\x02\b\x02\n\x02\f\x02\x0E\x02\x10\x02\x12" +
		"\x02\x14\x02\x16\x02\x18\x02\x1A\x02\x1C\x02\x1E\x02 \x02\"\x02$\x02&" +
		"\x02(\x02*\x02,\x02.\x020\x02\x02\n\x03\x0289\x03\x02;<\x04\x02\f\r\x18" +
		"\x18\x03\x02\f\x0F\x03\x02\x10\x13\x03\x02\x14\x15\x03\x02\x16\x17\x03" +
		"\x02\n\v\x02\u01CA\x025\x03\x02\x02\x02\x04;\x03\x02\x02\x02\x06L\x03" +
		"\x02\x02\x02\bT\x03\x02\x02\x02\n\xA1\x03\x02\x02\x02\f\xC9\x03\x02\x02" +
		"\x02\x0E\xCB\x03\x02\x02\x02\x10\xDF\x03\x02\x02\x02\x12\xE4\x03\x02\x02" +
		"\x02\x14\xE6\x03\x02\x02\x02\x16\xF1\x03\x02\x02\x02\x18\u0117\x03\x02" +
		"\x02\x02\x1A\u012C\x03\x02\x02\x02\x1C\u0142\x03\x02\x02\x02\x1E\u0146" +
		"\x03\x02\x02\x02 \u0148\x03\x02\x02\x02\"\u0169\x03\x02\x02\x02$\u016F" +
		"\x03\x02\x02\x02&\u0171\x03\x02\x02\x02(\u0173\x03\x02\x02\x02*\u017A" +
		"\x03\x02\x02\x02,\u0187\x03\x02\x02\x02.\u0190\x03\x02\x02\x020\u0197" +
		"\x03\x02\x02\x0224\x05\x04\x03\x0232\x03\x02\x02\x0247\x03\x02\x02\x02" +
		"53\x03\x02\x02\x0256\x03\x02\x02\x0268\x03\x02\x02\x0275\x03\x02\x02\x02" +
		"89\x05\n\x06\x029:\x07\x02\x02\x03:\x03\x03\x02\x02\x02;<\x07!\x02\x02" +
		"<=\x07>\x02\x02=?\x07\x19\x02\x02>@\x05\x06\x04\x02?>\x03\x02\x02\x02" +
		"?@\x03\x02\x02\x02@A\x03\x02\x02\x02AD\x07\x1A\x02\x02BC\x07\x05\x02\x02" +
		"CE\x05\x1E\x10\x02DB\x03\x02\x02\x02DE\x03\x02\x02\x02EF\x03\x02\x02\x02" +
		"FH\x07\x1B\x02\x02GI\x05\n\x06\x02HG\x03\x02\x02\x02HI\x03\x02\x02\x02" +
		"IJ\x03\x02\x02\x02JK\x07\x1C\x02\x02K\x05\x03\x02\x02\x02LQ\x05\b\x05" +
		"\x02MN\x07\b\x02\x02NP\x05\b\x05\x02OM\x03\x02\x02\x02PS\x03\x02\x02\x02" +
		"QO\x03\x02\x02\x02QR\x03\x02\x02\x02R\x07\x03\x02\x02\x02SQ\x03\x02\x02" +
		"\x02TU\x07>\x02\x02UV\x07\x05\x02\x02VW\x05\x1E\x10\x02W\t\x03\x02\x02" +
		"\x02XY\b\x06\x01\x02YZ\x07(\x02\x02Z[\x07\x19\x02\x02[\\\x05\x18\r\x02" +
		"\\]\x07\x1A\x02\x02]^\x07\x04\x02\x02^\xA2\x03\x02\x02\x02_`\x07 \x02" +
		"\x02`c\x07>\x02\x02ab\x07\x05\x02\x02bd\x05\x1E\x10\x02ca\x03\x02\x02" +
		"\x02cd\x03\x02\x02\x02de\x03\x02\x02\x02ef\x07\x07\x02\x02fg\x05\x18\r" +
		"\x02gh\x07\x04\x02\x02h\xA2\x03\x02\x02\x02ij\x05\x12\n\x02jk\x07\x07" +
		"\x02\x02kl\x05\x18\r\x02lm\x07\x04\x02\x02m\xA2\x03\x02\x02\x02no\x07" +
		".\x02\x02op\x07\x19\x02\x02pq\x05\x18\r\x02qr\x07\x1A\x02\x02rt\x07\x1B" +
		"\x02\x02su\x05\n\x06\x02ts\x03\x02\x02\x02tu\x03\x02\x02\x02uv\x03\x02" +
		"\x02\x02vz\x07\x1C\x02\x02wy\x05\x14\v\x02xw\x03\x02\x02\x02y|\x03\x02" +
		"\x02\x02zx\x03\x02\x02\x02z{\x03\x02\x02\x02{\x83\x03\x02\x02\x02|z\x03" +
		"\x02\x02\x02}~\x07/\x02\x02~\x80\x07\x1B\x02\x02\x7F\x81\x05\n\x06\x02" +
		"\x80\x7F\x03\x02\x02\x02\x80\x81\x03\x02\x02\x02\x81\x82\x03\x02\x02\x02" +
		"\x82\x84\x07\x1C\x02\x02\x83}\x03\x02\x02\x02\x83\x84\x03\x02\x02\x02" +
		"\x84\xA2\x03\x02\x02\x02\x85\x86\x070\x02\x02\x86\x87\x07\x19\x02\x02" +
		"\x87\x88\x05\x18\r\x02\x88\x89\x07\x1A\x02\x02\x89\x8B\x07\x1B\x02\x02" +
		"\x8A\x8C\x05\n\x06\x02\x8B\x8A\x03\x02\x02\x02\x8B\x8C\x03\x02\x02\x02" +
		"\x8C\x8D\x03\x02\x02\x02\x8D\x8E\x07\x1C\x02\x02\x8E\xA2\x03\x02\x02\x02" +
		"\x8F\x90\x071\x02\x02\x90\x91\x05\x0E\b\x02\x91\x93\x07\x1B\x02\x02\x92" +
		"\x94\x05\n\x06\x02\x93\x92\x03\x02\x02\x02\x93\x94\x03\x02\x02\x02\x94" +
		"\x95\x03\x02\x02\x02\x95\x96\x07\x1C\x02\x02\x96\xA2\x03\x02\x02\x02\x97" +
		"\xA2\x05\x10\t\x02\x98\x99\x05\x1C\x0F\x02\x99\x9A\x07\x04\x02\x02\x9A" +
		"\xA2\x03\x02\x02\x02\x9B\x9D\x07\"\x02\x02\x9C\x9E\x05\x18\r\x02\x9D\x9C" +
		"\x03\x02\x02\x02\x9D\x9E\x03\x02\x02\x02\x9E\x9F\x03\x02\x02\x02\x9F\xA2" +
		"\x07\x04\x02\x02\xA0\xA2\x05\f\x07\x02\xA1X\x03\x02\x02\x02\xA1_\x03\x02" +
		"\x02\x02\xA1i\x03\x02\x02\x02\xA1n\x03\x02\x02\x02\xA1\x85\x03\x02\x02" +
		"\x02\xA1\x8F\x03\x02\x02\x02\xA1\x97\x03\x02\x02\x02\xA1\x98\x03\x02\x02" +
		"\x02\xA1\x9B\x03\x02\x02\x02\xA1\xA0\x03\x02\x02\x02\xA2\xA7\x03\x02\x02" +
		"\x02\xA3\xA4\f\x06\x02\x02\xA4\xA6\x05\n\x06\x07\xA5\xA3\x03\x02\x02\x02" +
		"\xA6\xA9\x03\x02\x02\x02\xA7\xA5\x03\x02\x02\x02\xA7\xA8\x03\x02\x02\x02" +
		"\xA8\v\x03\x02\x02\x02\xA9\xA7\x03\x02\x02\x02\xAA\xAF\t\x02\x02\x02\xAB" +
		"\xAC\x07\x19\x02\x02\xAC\xAD\x05\x18\r\x02\xAD\xAE\x07\x1A\x02\x02\xAE" +
		"\xB0\x03\x02\x02\x02\xAF\xAB\x03\x02\x02\x02\xAF\xB0\x03\x02\x02\x02\xB0" +
		"\xB1\x03\x02\x02\x02\xB1\xB2\x07\x1B\x02\x02\xB2\xB3\x05\n\x06\x02\xB3" +
		"\xB4\x07\x1C\x02\x02\xB4\xCA\x03\x02\x02\x02\xB5\xBA\x07:\x02\x02\xB6" +
		"\xB7\x07\x19\x02\x02\xB7\xB8\x05\x16\f\x02\xB8\xB9\x07\x1A\x02\x02\xB9" +
		"\xBB\x03\x02\x02\x02\xBA\xB6\x03\x02\x02\x02\xBA\xBB\x03\x02\x02\x02\xBB" +
		"\xBC\x03\x02\x02\x02\xBC\xBD\x07\x1B\x02\x02\xBD\xBE\x05\n\x06\x02\xBE" +
		"\xBF\x07\x1C\x02\x02\xBF\xCA\x03\x02\x02\x02\xC0\xC1\t\x03\x02\x02\xC1" +
		"\xC2\x07\x19\x02\x02\xC2\xC5\x05\x18\r\x02\xC3\xC4\x07\b\x02\x02\xC4\xC6" +
		"\x05\x16\f\x02\xC5\xC3\x03\x02\x02\x02\xC5\xC6\x03\x02\x02\x02\xC6\xC7" +
		"\x03\x02\x02\x02\xC7\xC8\x07\x1A\x02\x02\xC8\xCA\x03\x02\x02\x02\xC9\xAA" +
		"\x03\x02\x02\x02\xC9\xB5\x03\x02\x02\x02\xC9\xC0\x03\x02\x02\x02\xCA\r" +
		"\x03\x02\x02\x02\xCB\xCC\x07>\x02\x02\xCC\xCD\x072\x02\x02\xCD\xCE\x07" +
		"3\x02\x02\xCE\xD2\x07\x19\x02\x02\xCF\xD0\x05\x18\r\x02\xD0\xD1\x07\b" +
		"\x02\x02\xD1\xD3\x03\x02\x02\x02\xD2\xCF\x03\x02\x02\x02\xD2\xD3\x03\x02" +
		"\x02\x02\xD3\xD4\x03\x02\x02\x02\xD4\xD7\x05\x18\r\x02\xD5\xD6\x07\b\x02" +
		"\x02\xD6\xD8\x05\x18\r\x02\xD7\xD5\x03\x02\x02\x02\xD7\xD8\x03\x02\x02" +
		"\x02\xD8\xD9\x03\x02\x02\x02\xD9\xDA\x07\x1A\x02\x02\xDA\x0F\x03\x02\x02" +
		"\x02\xDB\xDC\x074\x02\x02\xDC\xE0\x07\x04\x02\x02\xDD\xDE\x075\x02\x02" +
		"\xDE\xE0\x07\x04\x02\x02\xDF\xDB\x03\x02\x02\x02\xDF\xDD\x03\x02\x02\x02" +
		"\xE0\x11\x03\x02\x02\x02\xE1\xE5\x07>\x02\x02\xE2\xE5\x05,\x17\x02\xE3" +
		"\xE5\x05.\x18\x02\xE4\xE1\x03\x02\x02\x02\xE4\xE2\x03\x02\x02\x02\xE4" +
		"\xE3\x03\x02\x02\x02\xE5\x13\x03\x02\x02\x02\xE6\xE7\x07/\x02\x02\xE7" +
		"\xE8\x07.\x02\x02\xE8\xE9\x07\x19\x02\x02\xE9\xEA\x05\x18\r\x02\xEA\xEB" +
		"\x07\x1A\x02\x02\xEB\xED\x07\x1B\x02\x02\xEC\xEE\x05\n\x06\x02\xED\xEC" +
		"\x03\x02\x02\x02\xED\xEE\x03\x02\x02\x02\xEE\xEF\x03\x02\x02\x02\xEF\xF0" +
		"\x07\x1C\x02\x02\xF0\x15\x03\x02\x02\x02\xF1\xF6\x05\x18\r\x02\xF2\xF3" +
		"\x07\b\x02\x02\xF3\xF5\x05\x18\r\x02\xF4\xF2\x03\x02\x02\x02\xF5\xF8\x03" +
		"\x02\x02\x02\xF6\xF4\x03\x02\x02\x02\xF6\xF7\x03\x02\x02\x02\xF7\x17\x03" +
		"\x02\x02\x02\xF8\xF6\x03\x02\x02\x02\xF9\xFA\b\r\x01\x02\xFA\u0118\x07" +
		"?\x02\x02\xFB\u0118\x07@\x02\x02\xFC\u0118\x07=\x02\x02\xFD\u0118\x05" +
		"&\x14\x02\xFE\u0118\x07A\x02\x02\xFF\u0118\x07>\x02\x02\u0100\u0118\x05" +
		",\x17\x02\u0101\u0118\x05.\x18\x02\u0102\u0103\x05\"\x12\x02\u0103\u0105" +
		"\x07\x19\x02\x02\u0104\u0106\x05\x16\f\x02\u0105\u0104\x03\x02\x02\x02" +
		"\u0105\u0106\x03\x02\x02\x02\u0106\u0107\x03\x02\x02\x02\u0107\u0109\x07" +
		"\x1A\x02\x02\u0108\u010A\x05(\x15\x02\u0109\u0108\x03\x02\x02\x02\u0109" +
		"\u010A\x03\x02\x02\x02\u010A\u0118\x03\x02\x02\x02\u010B\u0118\x05\x1C" +
		"\x0F\x02\u010C\u010D\t\x04\x02\x02\u010D\u0118\x05\x18\r\t\u010E\u010F" +
		"\x05\x1A\x0E\x02\u010F\u0110\x07\x19\x02\x02\u0110\u0111\x05\x18\r\x02" +
		"\u0111\u0112\x07\x1A\x02\x02\u0112\u0118\x03\x02\x02\x02\u0113\u0114\x07" +
		"\x19\x02\x02\u0114\u0115\x05\x18\r\x02\u0115\u0116\x07\x1A\x02\x02\u0116" +
		"\u0118\x03\x02\x02\x02\u0117\xF9\x03\x02\x02\x02\u0117\xFB\x03\x02\x02" +
		"\x02\u0117\xFC\x03\x02\x02\x02\u0117\xFD\x03\x02\x02\x02\u0117\xFE\x03" +
		"\x02\x02\x02\u0117\xFF\x03\x02\x02\x02\u0117\u0100\x03\x02\x02\x02\u0117" +
		"\u0101\x03\x02\x02\x02\u0117\u0102\x03\x02\x02\x02\u0117\u010B\x03\x02" +
		"\x02\x02\u0117\u010C\x03\x02\x02\x02\u0117\u010E\x03\x02\x02\x02\u0117" +
		"\u0113\x03\x02\x02\x02\u0118\u0127\x03\x02\x02\x02\u0119\u011A\f\b\x02" +
		"\x02\u011A\u011B\t\x05\x02\x02\u011B\u0126\x05\x18\r\t\u011C\u011D\f\x07" +
		"\x02\x02\u011D\u011E\t\x06\x02\x02\u011E\u0126\x05\x18\r\b\u011F\u0120" +
		"\f\x06\x02\x02\u0120\u0121\t\x07\x02\x02\u0121\u0126\x05\x18\r\x07\u0122" +
		"\u0123\f\x05\x02\x02\u0123\u0124\t\b\x02\x02\u0124\u0126\x05\x18\r\x06" +
		"\u0125\u0119\x03\x02\x02\x02\u0125\u011C\x03\x02\x02\x02\u0125\u011F\x03" +
		"\x02\x02\x02\u0125\u0122\x03\x02\x02\x02\u0126\u0129\x03\x02\x02\x02\u0127" +
		"\u0125\x03\x02\x02\x02\u0127\u0128\x03\x02\x02\x02\u0128\x19\x03\x02\x02" +
		"\x02\u0129\u0127\x03\x02\x02\x02\u012A\u012D\x076\x02\x02\u012B\u012D" +
		"\x077\x02\x02\u012C\u012A\x03\x02\x02\x02\u012C\u012B\x03\x02\x02\x02" +
		"\u012D\x1B\x03\x02\x02\x02\u012E\u0133\x07>\x02\x02\u012F\u0130\x07\x1D" +
		"\x02\x02\u0130\u0131\x05\x18\r\x02\u0131\u0132\x07\x1E\x02\x02\u0132\u0134" +
		"\x03\x02\x02\x02\u0133\u012F\x03\x02\x02\x02\u0133\u0134\x03\x02\x02\x02" +
		"\u0134\u0135\x03\x02\x02\x02\u0135\u0136\x07\x06\x02\x02\u0136\u0137\x07" +
		">\x02\x02\u0137\u0139\x07\x19\x02\x02\u0138\u013A\x05\x16\f\x02\u0139" +
		"\u0138\x03\x02\x02\x02\u0139\u013A\x03\x02\x02\x02\u013A\u013B\x03\x02" +
		"\x02\x02\u013B\u0143\x07\x1A\x02\x02\u013C\u013D\x07>\x02\x02\u013D\u013F" +
		"\x07\x19\x02\x02\u013E\u0140\x05\x16\f\x02\u013F\u013E\x03\x02\x02\x02" +
		"\u013F\u0140\x03\x02\x02\x02\u0140\u0141\x03\x02\x02\x02\u0141\u0143\x07" +
		"\x1A\x02\x02\u0142\u012E\x03\x02\x02\x02\u0142\u013C\x03\x02\x02\x02\u0143" +
		"\x1D\x03\x02\x02\x02\u0144\u0147\x05\"\x12\x02\u0145\u0147\x05$\x13\x02" +
		"\u0146\u0144\x03\x02\x02\x02\u0146\u0145\x03\x02\x02\x02\u0147\x1F\x03" +
		"\x02\x02\x02\u0148\u0149\x07-\x02\x02\u0149\u014A\x07\x10\x02\x02\u014A" +
		"\u014B\x05$\x13\x02\u014B\u014C\x07\x11\x02\x02\u014C!\x03\x02\x02\x02" +
		"\u014D\u014E\x07)\x02\x02\u014E\u014F\x07\x10\x02\x02\u014F\u0150\x05" +
		"$\x13\x02\u0150\u0151\x07\x11\x02\x02\u0151\u016A\x03\x02\x02\x02\u0152" +
		"\u0153\x07*\x02\x02\u0153\u0155\x07\x10\x02\x02\u0154\u0152\x03\x02\x02" +
		"\x02\u0155\u0156\x03\x02\x02\x02\u0156\u0154\x03\x02\x02\x02\u0156\u0157" +
		"\x03\x02\x02\x02\u0157\u0158\x03\x02\x02\x02\u0158\u015A\x05\x1E\x10\x02" +
		"\u0159\u015B\x07\x11\x02\x02\u015A\u0159\x03\x02\x02\x02\u015B\u015C\x03" +
		"\x02\x02\x02\u015C\u015A\x03\x02\x02\x02\u015C\u015D\x03\x02\x02\x02\u015D" +
		"\u016A\x03\x02\x02\x02\u015E\u015F\x07+\x02\x02\u015F\u0160\x07\x10\x02" +
		"\x02\u0160\u0161\x05\x1E\x10\x02\u0161\u0162\x07\x11\x02\x02\u0162\u016A" +
		"\x03\x02\x02\x02\u0163\u016A\x05 \x11\x02\u0164\u0165\x07,\x02\x02\u0165" +
		"\u0166\x07\x10\x02\x02\u0166\u0167\x05 \x11\x02\u0167\u0168\x07\x11\x02" +
		"\x02\u0168\u016A\x03\x02\x02\x02\u0169\u014D\x03\x02\x02\x02\u0169\u0154" +
		"\x03\x02\x02\x02\u0169\u015E\x03\x02\x02\x02\u0169\u0163\x03\x02\x02\x02" +
		"\u0169\u0164\x03\x02\x02\x02\u016A#\x03\x02\x02\x02\u016B\u0170\x07#\x02" +
		"\x02\u016C\u0170\x07$\x02\x02\u016D\u0170\x07%\x02\x02\u016E\u0170\x07" +
		"&\x02\x02\u016F\u016B\x03\x02\x02\x02\u016F\u016C\x03\x02\x02\x02\u016F" +
		"\u016D\x03\x02\x02\x02\u016F\u016E\x03\x02\x02\x02\u0170%\x03\x02\x02" +
		"\x02\u0171\u0172\t\t\x02\x02\u0172\'\x03\x02\x02\x02\u0173\u0176\x07\x1B" +
		"\x02\x02\u0174\u0177\x05\x16\f\x02\u0175\u0177\x05*\x16\x02\u0176\u0174" +
		"\x03\x02\x02\x02\u0176\u0175\x03\x02\x02\x02\u0177\u0178\x03\x02\x02\x02" +
		"\u0178\u0179\x07\x1C\x02\x02\u0179)\x03\x02\x02\x02\u017A\u017B\x07\x1D" +
		"\x02\x02\u017B\u017C\x05\x16\f\x02\u017C\u0184\x07\x1E\x02\x02\u017D\u017E" +
		"\x07\b\x02\x02\u017E\u017F\x07\x1D\x02\x02\u017F\u0180\x05\x16\f\x02\u0180" +
		"\u0181\x07\x1E\x02\x02\u0181\u0183\x03\x02\x02\x02\u0182\u017D\x03\x02" +
		"\x02\x02\u0183\u0186\x03\x02\x02\x02\u0184\u0182\x03\x02\x02\x02\u0184" +
		"\u0185\x03\x02\x02\x02\u0185+\x03\x02\x02\x02\u0186\u0184\x03\x02\x02" +
		"\x02\u0187\u018C\x07>\x02\x02\u0188\u0189\x07\x1D\x02\x02\u0189\u018A" +
		"\x05\x18\r\x02\u018A\u018B\x07\x1E\x02\x02\u018B\u018D\x03\x02\x02\x02" +
		"\u018C\u0188\x03\x02\x02\x02\u018D\u018E\x03\x02\x02\x02\u018E\u018C\x03" +
		"\x02\x02\x02\u018E\u018F\x03\x02\x02\x02\u018F-\x03\x02\x02\x02\u0190" +
		"\u0194\x07>\x02\x02\u0191\u0193\x050\x19\x02\u0192\u0191\x03\x02\x02\x02" +
		"\u0193\u0196\x03\x02\x02\x02\u0194\u0192\x03\x02\x02\x02\u0194\u0195\x03" +
		"\x02\x02\x02\u0195/\x03\x02\x02\x02\u0196\u0194\x03\x02\x02\x02\u0197" +
		"\u0198\x07\x06\x02\x02\u0198\u0199\x07>\x02\x02\u01991\x03\x02\x02\x02" +
		".5?DHQctz\x80\x83\x8B\x93\x9D\xA1\xA7\xAF\xBA\xC5\xC9\xD2\xD7\xDF\xE4" +
		"\xED\xF6\u0105\u0109\u0117\u0125\u0127\u012C\u0133\u0139\u013F\u0142\u0146" +
		"\u0156\u015C\u0169\u016F\u0176\u0184\u018E\u0194";
	public static __ATN: ATN;
	public static get _ATN(): ATN {
		if (!ManimParser.__ATN) {
			ManimParser.__ATN = new ATNDeserializer().deserialize(Utils.toCharArray(ManimParser._serializedATN));
		}

		return ManimParser.__ATN;
	}

}

export class ProgramContext extends ParserRuleContext {
	public stat(): StatContext {
		return this.getRuleContext(0, StatContext);
	}
	public EOF(): TerminalNode { return this.getToken(ManimParser.EOF, 0); }
	public function(): FunctionContext[];
	public function(i: number): FunctionContext;
	public function(i?: number): FunctionContext | FunctionContext[] {
		if (i === undefined) {
			return this.getRuleContexts(FunctionContext);
		} else {
			return this.getRuleContext(i, FunctionContext);
		}
	}
	constructor(parent: ParserRuleContext | undefined, invokingState: number) {
		super(parent, invokingState);
	}
	// @Override
	public get ruleIndex(): number { return ManimParser.RULE_program; }
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterProgram) {
			listener.enterProgram(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitProgram) {
			listener.exitProgram(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitProgram) {
			return visitor.visitProgram(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class FunctionContext extends ParserRuleContext {
	public _statements: StatContext;
	public FUN(): TerminalNode { return this.getToken(ManimParser.FUN, 0); }
	public IDENT(): TerminalNode { return this.getToken(ManimParser.IDENT, 0); }
	public OPEN_PARENTHESIS(): TerminalNode { return this.getToken(ManimParser.OPEN_PARENTHESIS, 0); }
	public CLOSE_PARENTHESIS(): TerminalNode { return this.getToken(ManimParser.CLOSE_PARENTHESIS, 0); }
	public OPEN_CURLY_BRACKET(): TerminalNode { return this.getToken(ManimParser.OPEN_CURLY_BRACKET, 0); }
	public CLOSE_CURLY_BRACKET(): TerminalNode { return this.getToken(ManimParser.CLOSE_CURLY_BRACKET, 0); }
	public param_list(): Param_listContext | undefined {
		return this.tryGetRuleContext(0, Param_listContext);
	}
	public COLON(): TerminalNode | undefined { return this.tryGetToken(ManimParser.COLON, 0); }
	public type(): TypeContext | undefined {
		return this.tryGetRuleContext(0, TypeContext);
	}
	public stat(): StatContext | undefined {
		return this.tryGetRuleContext(0, StatContext);
	}
	constructor(parent: ParserRuleContext | undefined, invokingState: number) {
		super(parent, invokingState);
	}
	// @Override
	public get ruleIndex(): number { return ManimParser.RULE_function; }
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterFunction) {
			listener.enterFunction(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitFunction) {
			listener.exitFunction(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitFunction) {
			return visitor.visitFunction(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class Param_listContext extends ParserRuleContext {
	constructor(parent: ParserRuleContext | undefined, invokingState: number) {
		super(parent, invokingState);
	}
	// @Override
	public get ruleIndex(): number { return ManimParser.RULE_param_list; }
	public copyFrom(ctx: Param_listContext): void {
		super.copyFrom(ctx);
	}
}
export class ParameterListContext extends Param_listContext {
	public param(): ParamContext[];
	public param(i: number): ParamContext;
	public param(i?: number): ParamContext | ParamContext[] {
		if (i === undefined) {
			return this.getRuleContexts(ParamContext);
		} else {
			return this.getRuleContext(i, ParamContext);
		}
	}
	public COMMA(): TerminalNode[];
	public COMMA(i: number): TerminalNode;
	public COMMA(i?: number): TerminalNode | TerminalNode[] {
		if (i === undefined) {
			return this.getTokens(ManimParser.COMMA);
		} else {
			return this.getToken(ManimParser.COMMA, i);
		}
	}
	constructor(ctx: Param_listContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterParameterList) {
			listener.enterParameterList(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitParameterList) {
			listener.exitParameterList(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitParameterList) {
			return visitor.visitParameterList(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class ParamContext extends ParserRuleContext {
	constructor(parent: ParserRuleContext | undefined, invokingState: number) {
		super(parent, invokingState);
	}
	// @Override
	public get ruleIndex(): number { return ManimParser.RULE_param; }
	public copyFrom(ctx: ParamContext): void {
		super.copyFrom(ctx);
	}
}
export class ParameterContext extends ParamContext {
	public IDENT(): TerminalNode { return this.getToken(ManimParser.IDENT, 0); }
	public COLON(): TerminalNode { return this.getToken(ManimParser.COLON, 0); }
	public type(): TypeContext {
		return this.getRuleContext(0, TypeContext);
	}
	constructor(ctx: ParamContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterParameter) {
			listener.enterParameter(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitParameter) {
			listener.exitParameter(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitParameter) {
			return visitor.visitParameter(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class StatContext extends ParserRuleContext {
	constructor(parent: ParserRuleContext | undefined, invokingState: number) {
		super(parent, invokingState);
	}
	// @Override
	public get ruleIndex(): number { return ManimParser.RULE_stat; }
	public copyFrom(ctx: StatContext): void {
		super.copyFrom(ctx);
	}
}
export class SleepStatementContext extends StatContext {
	public SLEEP(): TerminalNode { return this.getToken(ManimParser.SLEEP, 0); }
	public OPEN_PARENTHESIS(): TerminalNode { return this.getToken(ManimParser.OPEN_PARENTHESIS, 0); }
	public expr(): ExprContext {
		return this.getRuleContext(0, ExprContext);
	}
	public CLOSE_PARENTHESIS(): TerminalNode { return this.getToken(ManimParser.CLOSE_PARENTHESIS, 0); }
	public SEMI(): TerminalNode { return this.getToken(ManimParser.SEMI, 0); }
	constructor(ctx: StatContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterSleepStatement) {
			listener.enterSleepStatement(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitSleepStatement) {
			listener.exitSleepStatement(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitSleepStatement) {
			return visitor.visitSleepStatement(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class DeclarationStatementContext extends StatContext {
	public LET(): TerminalNode { return this.getToken(ManimParser.LET, 0); }
	public IDENT(): TerminalNode { return this.getToken(ManimParser.IDENT, 0); }
	public EQUAL(): TerminalNode { return this.getToken(ManimParser.EQUAL, 0); }
	public expr(): ExprContext {
		return this.getRuleContext(0, ExprContext);
	}
	public SEMI(): TerminalNode { return this.getToken(ManimParser.SEMI, 0); }
	public COLON(): TerminalNode | undefined { return this.tryGetToken(ManimParser.COLON, 0); }
	public type(): TypeContext | undefined {
		return this.tryGetRuleContext(0, TypeContext);
	}
	constructor(ctx: StatContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterDeclarationStatement) {
			listener.enterDeclarationStatement(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitDeclarationStatement) {
			listener.exitDeclarationStatement(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitDeclarationStatement) {
			return visitor.visitDeclarationStatement(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class AssignmentStatementContext extends StatContext {
	public assignment_lhs(): Assignment_lhsContext {
		return this.getRuleContext(0, Assignment_lhsContext);
	}
	public EQUAL(): TerminalNode { return this.getToken(ManimParser.EQUAL, 0); }
	public expr(): ExprContext {
		return this.getRuleContext(0, ExprContext);
	}
	public SEMI(): TerminalNode { return this.getToken(ManimParser.SEMI, 0); }
	constructor(ctx: StatContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterAssignmentStatement) {
			listener.enterAssignmentStatement(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitAssignmentStatement) {
			listener.exitAssignmentStatement(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitAssignmentStatement) {
			return visitor.visitAssignmentStatement(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class IfStatementContext extends StatContext {
	public _ifCond: ExprContext;
	public _ifStat: StatContext;
	public _elseStat: StatContext;
	public IF(): TerminalNode { return this.getToken(ManimParser.IF, 0); }
	public OPEN_PARENTHESIS(): TerminalNode { return this.getToken(ManimParser.OPEN_PARENTHESIS, 0); }
	public CLOSE_PARENTHESIS(): TerminalNode { return this.getToken(ManimParser.CLOSE_PARENTHESIS, 0); }
	public OPEN_CURLY_BRACKET(): TerminalNode[];
	public OPEN_CURLY_BRACKET(i: number): TerminalNode;
	public OPEN_CURLY_BRACKET(i?: number): TerminalNode | TerminalNode[] {
		if (i === undefined) {
			return this.getTokens(ManimParser.OPEN_CURLY_BRACKET);
		} else {
			return this.getToken(ManimParser.OPEN_CURLY_BRACKET, i);
		}
	}
	public CLOSE_CURLY_BRACKET(): TerminalNode[];
	public CLOSE_CURLY_BRACKET(i: number): TerminalNode;
	public CLOSE_CURLY_BRACKET(i?: number): TerminalNode | TerminalNode[] {
		if (i === undefined) {
			return this.getTokens(ManimParser.CLOSE_CURLY_BRACKET);
		} else {
			return this.getToken(ManimParser.CLOSE_CURLY_BRACKET, i);
		}
	}
	public expr(): ExprContext {
		return this.getRuleContext(0, ExprContext);
	}
	public elseIf(): ElseIfContext[];
	public elseIf(i: number): ElseIfContext;
	public elseIf(i?: number): ElseIfContext | ElseIfContext[] {
		if (i === undefined) {
			return this.getRuleContexts(ElseIfContext);
		} else {
			return this.getRuleContext(i, ElseIfContext);
		}
	}
	public ELSE(): TerminalNode | undefined { return this.tryGetToken(ManimParser.ELSE, 0); }
	public stat(): StatContext[];
	public stat(i: number): StatContext;
	public stat(i?: number): StatContext | StatContext[] {
		if (i === undefined) {
			return this.getRuleContexts(StatContext);
		} else {
			return this.getRuleContext(i, StatContext);
		}
	}
	constructor(ctx: StatContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterIfStatement) {
			listener.enterIfStatement(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitIfStatement) {
			listener.exitIfStatement(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitIfStatement) {
			return visitor.visitIfStatement(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class WhileStatementContext extends StatContext {
	public _whileCond: ExprContext;
	public _whileStat: StatContext;
	public WHILE(): TerminalNode { return this.getToken(ManimParser.WHILE, 0); }
	public OPEN_PARENTHESIS(): TerminalNode { return this.getToken(ManimParser.OPEN_PARENTHESIS, 0); }
	public CLOSE_PARENTHESIS(): TerminalNode { return this.getToken(ManimParser.CLOSE_PARENTHESIS, 0); }
	public OPEN_CURLY_BRACKET(): TerminalNode { return this.getToken(ManimParser.OPEN_CURLY_BRACKET, 0); }
	public CLOSE_CURLY_BRACKET(): TerminalNode { return this.getToken(ManimParser.CLOSE_CURLY_BRACKET, 0); }
	public expr(): ExprContext {
		return this.getRuleContext(0, ExprContext);
	}
	public stat(): StatContext | undefined {
		return this.tryGetRuleContext(0, StatContext);
	}
	constructor(ctx: StatContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterWhileStatement) {
			listener.enterWhileStatement(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitWhileStatement) {
			listener.exitWhileStatement(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitWhileStatement) {
			return visitor.visitWhileStatement(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class ForStatementContext extends StatContext {
	public _forStat: StatContext;
	public FOR(): TerminalNode { return this.getToken(ManimParser.FOR, 0); }
	public forHeader(): ForHeaderContext {
		return this.getRuleContext(0, ForHeaderContext);
	}
	public OPEN_CURLY_BRACKET(): TerminalNode { return this.getToken(ManimParser.OPEN_CURLY_BRACKET, 0); }
	public CLOSE_CURLY_BRACKET(): TerminalNode { return this.getToken(ManimParser.CLOSE_CURLY_BRACKET, 0); }
	public stat(): StatContext | undefined {
		return this.tryGetRuleContext(0, StatContext);
	}
	constructor(ctx: StatContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterForStatement) {
			listener.enterForStatement(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitForStatement) {
			listener.exitForStatement(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitForStatement) {
			return visitor.visitForStatement(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class LoopStatementContext extends StatContext {
	public loop_stat(): Loop_statContext {
		return this.getRuleContext(0, Loop_statContext);
	}
	constructor(ctx: StatContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterLoopStatement) {
			listener.enterLoopStatement(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitLoopStatement) {
			listener.exitLoopStatement(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitLoopStatement) {
			return visitor.visitLoopStatement(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class ConsecutiveStatementContext extends StatContext {
	public _stat1: StatContext;
	public _stat2: StatContext;
	public stat(): StatContext[];
	public stat(i: number): StatContext;
	public stat(i?: number): StatContext | StatContext[] {
		if (i === undefined) {
			return this.getRuleContexts(StatContext);
		} else {
			return this.getRuleContext(i, StatContext);
		}
	}
	constructor(ctx: StatContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterConsecutiveStatement) {
			listener.enterConsecutiveStatement(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitConsecutiveStatement) {
			listener.exitConsecutiveStatement(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitConsecutiveStatement) {
			return visitor.visitConsecutiveStatement(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class MethodCallStatementContext extends StatContext {
	public method_call(): Method_callContext {
		return this.getRuleContext(0, Method_callContext);
	}
	public SEMI(): TerminalNode { return this.getToken(ManimParser.SEMI, 0); }
	constructor(ctx: StatContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterMethodCallStatement) {
			listener.enterMethodCallStatement(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitMethodCallStatement) {
			listener.exitMethodCallStatement(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitMethodCallStatement) {
			return visitor.visitMethodCallStatement(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class ReturnStatementContext extends StatContext {
	public RETURN(): TerminalNode { return this.getToken(ManimParser.RETURN, 0); }
	public SEMI(): TerminalNode { return this.getToken(ManimParser.SEMI, 0); }
	public expr(): ExprContext | undefined {
		return this.tryGetRuleContext(0, ExprContext);
	}
	constructor(ctx: StatContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterReturnStatement) {
			listener.enterReturnStatement(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitReturnStatement) {
			listener.exitReturnStatement(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitReturnStatement) {
			return visitor.visitReturnStatement(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class AnnotationStatementContext extends StatContext {
	public annotation(): AnnotationContext {
		return this.getRuleContext(0, AnnotationContext);
	}
	constructor(ctx: StatContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterAnnotationStatement) {
			listener.enterAnnotationStatement(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitAnnotationStatement) {
			listener.exitAnnotationStatement(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitAnnotationStatement) {
			return visitor.visitAnnotationStatement(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class AnnotationContext extends ParserRuleContext {
	constructor(parent: ParserRuleContext | undefined, invokingState: number) {
		super(parent, invokingState);
	}
	// @Override
	public get ruleIndex(): number { return ManimParser.RULE_annotation; }
	public copyFrom(ctx: AnnotationContext): void {
		super.copyFrom(ctx);
	}
}
export class CodeTrackingAnnotationContext extends AnnotationContext {
	public _step: Token;
	public _condition: ExprContext;
	public OPEN_CURLY_BRACKET(): TerminalNode { return this.getToken(ManimParser.OPEN_CURLY_BRACKET, 0); }
	public stat(): StatContext {
		return this.getRuleContext(0, StatContext);
	}
	public CLOSE_CURLY_BRACKET(): TerminalNode { return this.getToken(ManimParser.CLOSE_CURLY_BRACKET, 0); }
	public STEP_INTO(): TerminalNode | undefined { return this.tryGetToken(ManimParser.STEP_INTO, 0); }
	public STEP_OVER(): TerminalNode | undefined { return this.tryGetToken(ManimParser.STEP_OVER, 0); }
	public OPEN_PARENTHESIS(): TerminalNode | undefined { return this.tryGetToken(ManimParser.OPEN_PARENTHESIS, 0); }
	public CLOSE_PARENTHESIS(): TerminalNode | undefined { return this.tryGetToken(ManimParser.CLOSE_PARENTHESIS, 0); }
	public expr(): ExprContext | undefined {
		return this.tryGetRuleContext(0, ExprContext);
	}
	constructor(ctx: AnnotationContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterCodeTrackingAnnotation) {
			listener.enterCodeTrackingAnnotation(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitCodeTrackingAnnotation) {
			listener.exitCodeTrackingAnnotation(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitCodeTrackingAnnotation) {
			return visitor.visitCodeTrackingAnnotation(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class AnimationSpeedUpAnnotationContext extends AnnotationContext {
	public SPEED(): TerminalNode { return this.getToken(ManimParser.SPEED, 0); }
	public OPEN_CURLY_BRACKET(): TerminalNode { return this.getToken(ManimParser.OPEN_CURLY_BRACKET, 0); }
	public stat(): StatContext {
		return this.getRuleContext(0, StatContext);
	}
	public CLOSE_CURLY_BRACKET(): TerminalNode { return this.getToken(ManimParser.CLOSE_CURLY_BRACKET, 0); }
	public OPEN_PARENTHESIS(): TerminalNode | undefined { return this.tryGetToken(ManimParser.OPEN_PARENTHESIS, 0); }
	public arg_list(): Arg_listContext | undefined {
		return this.tryGetRuleContext(0, Arg_listContext);
	}
	public CLOSE_PARENTHESIS(): TerminalNode | undefined { return this.tryGetToken(ManimParser.CLOSE_PARENTHESIS, 0); }
	constructor(ctx: AnnotationContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterAnimationSpeedUpAnnotation) {
			listener.enterAnimationSpeedUpAnnotation(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitAnimationSpeedUpAnnotation) {
			listener.exitAnimationSpeedUpAnnotation(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitAnimationSpeedUpAnnotation) {
			return visitor.visitAnimationSpeedUpAnnotation(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class SubtitleAnnotationContext extends AnnotationContext {
	public _show: Token;
	public _subtitle_text: ExprContext;
	public OPEN_PARENTHESIS(): TerminalNode { return this.getToken(ManimParser.OPEN_PARENTHESIS, 0); }
	public CLOSE_PARENTHESIS(): TerminalNode { return this.getToken(ManimParser.CLOSE_PARENTHESIS, 0); }
	public expr(): ExprContext {
		return this.getRuleContext(0, ExprContext);
	}
	public SUBTITLE(): TerminalNode | undefined { return this.tryGetToken(ManimParser.SUBTITLE, 0); }
	public SUBTITLE_ONCE(): TerminalNode | undefined { return this.tryGetToken(ManimParser.SUBTITLE_ONCE, 0); }
	public COMMA(): TerminalNode | undefined { return this.tryGetToken(ManimParser.COMMA, 0); }
	public arg_list(): Arg_listContext | undefined {
		return this.tryGetRuleContext(0, Arg_listContext);
	}
	constructor(ctx: AnnotationContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterSubtitleAnnotation) {
			listener.enterSubtitleAnnotation(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitSubtitleAnnotation) {
			listener.exitSubtitleAnnotation(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitSubtitleAnnotation) {
			return visitor.visitSubtitleAnnotation(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class ForHeaderContext extends ParserRuleContext {
	constructor(parent: ParserRuleContext | undefined, invokingState: number) {
		super(parent, invokingState);
	}
	// @Override
	public get ruleIndex(): number { return ManimParser.RULE_forHeader; }
	public copyFrom(ctx: ForHeaderContext): void {
		super.copyFrom(ctx);
	}
}
export class RangeHeaderContext extends ForHeaderContext {
	public _begin: ExprContext;
	public _end: ExprContext;
	public _delta: ExprContext;
	public IDENT(): TerminalNode { return this.getToken(ManimParser.IDENT, 0); }
	public IN(): TerminalNode { return this.getToken(ManimParser.IN, 0); }
	public RANGE(): TerminalNode { return this.getToken(ManimParser.RANGE, 0); }
	public OPEN_PARENTHESIS(): TerminalNode { return this.getToken(ManimParser.OPEN_PARENTHESIS, 0); }
	public CLOSE_PARENTHESIS(): TerminalNode { return this.getToken(ManimParser.CLOSE_PARENTHESIS, 0); }
	public expr(): ExprContext[];
	public expr(i: number): ExprContext;
	public expr(i?: number): ExprContext | ExprContext[] {
		if (i === undefined) {
			return this.getRuleContexts(ExprContext);
		} else {
			return this.getRuleContext(i, ExprContext);
		}
	}
	public COMMA(): TerminalNode[];
	public COMMA(i: number): TerminalNode;
	public COMMA(i?: number): TerminalNode | TerminalNode[] {
		if (i === undefined) {
			return this.getTokens(ManimParser.COMMA);
		} else {
			return this.getToken(ManimParser.COMMA, i);
		}
	}
	constructor(ctx: ForHeaderContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterRangeHeader) {
			listener.enterRangeHeader(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitRangeHeader) {
			listener.exitRangeHeader(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitRangeHeader) {
			return visitor.visitRangeHeader(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class Loop_statContext extends ParserRuleContext {
	constructor(parent: ParserRuleContext | undefined, invokingState: number) {
		super(parent, invokingState);
	}
	// @Override
	public get ruleIndex(): number { return ManimParser.RULE_loop_stat; }
	public copyFrom(ctx: Loop_statContext): void {
		super.copyFrom(ctx);
	}
}
export class BreakStatementContext extends Loop_statContext {
	public BREAK(): TerminalNode { return this.getToken(ManimParser.BREAK, 0); }
	public SEMI(): TerminalNode { return this.getToken(ManimParser.SEMI, 0); }
	constructor(ctx: Loop_statContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterBreakStatement) {
			listener.enterBreakStatement(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitBreakStatement) {
			listener.exitBreakStatement(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitBreakStatement) {
			return visitor.visitBreakStatement(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class ContinueStatementContext extends Loop_statContext {
	public CONTINUE(): TerminalNode { return this.getToken(ManimParser.CONTINUE, 0); }
	public SEMI(): TerminalNode { return this.getToken(ManimParser.SEMI, 0); }
	constructor(ctx: Loop_statContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterContinueStatement) {
			listener.enterContinueStatement(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitContinueStatement) {
			listener.exitContinueStatement(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitContinueStatement) {
			return visitor.visitContinueStatement(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class Assignment_lhsContext extends ParserRuleContext {
	constructor(parent: ParserRuleContext | undefined, invokingState: number) {
		super(parent, invokingState);
	}
	// @Override
	public get ruleIndex(): number { return ManimParser.RULE_assignment_lhs; }
	public copyFrom(ctx: Assignment_lhsContext): void {
		super.copyFrom(ctx);
	}
}
export class IdentifierAssignmentContext extends Assignment_lhsContext {
	public IDENT(): TerminalNode { return this.getToken(ManimParser.IDENT, 0); }
	constructor(ctx: Assignment_lhsContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterIdentifierAssignment) {
			listener.enterIdentifierAssignment(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitIdentifierAssignment) {
			listener.exitIdentifierAssignment(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitIdentifierAssignment) {
			return visitor.visitIdentifierAssignment(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class ArrayElemAssignmentContext extends Assignment_lhsContext {
	public array_elem(): Array_elemContext {
		return this.getRuleContext(0, Array_elemContext);
	}
	constructor(ctx: Assignment_lhsContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterArrayElemAssignment) {
			listener.enterArrayElemAssignment(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitArrayElemAssignment) {
			listener.exitArrayElemAssignment(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitArrayElemAssignment) {
			return visitor.visitArrayElemAssignment(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class NodeElemAssignmentContext extends Assignment_lhsContext {
	public node_elem(): Node_elemContext {
		return this.getRuleContext(0, Node_elemContext);
	}
	constructor(ctx: Assignment_lhsContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterNodeElemAssignment) {
			listener.enterNodeElemAssignment(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitNodeElemAssignment) {
			listener.exitNodeElemAssignment(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitNodeElemAssignment) {
			return visitor.visitNodeElemAssignment(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class ElseIfContext extends ParserRuleContext {
	public _elifCond: ExprContext;
	public _elifStat: StatContext;
	public ELSE(): TerminalNode { return this.getToken(ManimParser.ELSE, 0); }
	public IF(): TerminalNode { return this.getToken(ManimParser.IF, 0); }
	public OPEN_PARENTHESIS(): TerminalNode { return this.getToken(ManimParser.OPEN_PARENTHESIS, 0); }
	public CLOSE_PARENTHESIS(): TerminalNode { return this.getToken(ManimParser.CLOSE_PARENTHESIS, 0); }
	public OPEN_CURLY_BRACKET(): TerminalNode { return this.getToken(ManimParser.OPEN_CURLY_BRACKET, 0); }
	public CLOSE_CURLY_BRACKET(): TerminalNode { return this.getToken(ManimParser.CLOSE_CURLY_BRACKET, 0); }
	public expr(): ExprContext {
		return this.getRuleContext(0, ExprContext);
	}
	public stat(): StatContext | undefined {
		return this.tryGetRuleContext(0, StatContext);
	}
	constructor(parent: ParserRuleContext | undefined, invokingState: number) {
		super(parent, invokingState);
	}
	// @Override
	public get ruleIndex(): number { return ManimParser.RULE_elseIf; }
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterElseIf) {
			listener.enterElseIf(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitElseIf) {
			listener.exitElseIf(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitElseIf) {
			return visitor.visitElseIf(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class Arg_listContext extends ParserRuleContext {
	constructor(parent: ParserRuleContext | undefined, invokingState: number) {
		super(parent, invokingState);
	}
	// @Override
	public get ruleIndex(): number { return ManimParser.RULE_arg_list; }
	public copyFrom(ctx: Arg_listContext): void {
		super.copyFrom(ctx);
	}
}
export class ArgumentListContext extends Arg_listContext {
	public expr(): ExprContext[];
	public expr(i: number): ExprContext;
	public expr(i?: number): ExprContext | ExprContext[] {
		if (i === undefined) {
			return this.getRuleContexts(ExprContext);
		} else {
			return this.getRuleContext(i, ExprContext);
		}
	}
	public COMMA(): TerminalNode[];
	public COMMA(i: number): TerminalNode;
	public COMMA(i?: number): TerminalNode | TerminalNode[] {
		if (i === undefined) {
			return this.getTokens(ManimParser.COMMA);
		} else {
			return this.getToken(ManimParser.COMMA, i);
		}
	}
	constructor(ctx: Arg_listContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterArgumentList) {
			listener.enterArgumentList(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitArgumentList) {
			listener.exitArgumentList(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitArgumentList) {
			return visitor.visitArgumentList(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class ExprContext extends ParserRuleContext {
	constructor(parent: ParserRuleContext | undefined, invokingState: number) {
		super(parent, invokingState);
	}
	// @Override
	public get ruleIndex(): number { return ManimParser.RULE_expr; }
	public copyFrom(ctx: ExprContext): void {
		super.copyFrom(ctx);
	}
}
export class NumberLiteralContext extends ExprContext {
	public NUMBER(): TerminalNode { return this.getToken(ManimParser.NUMBER, 0); }
	constructor(ctx: ExprContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterNumberLiteral) {
			listener.enterNumberLiteral(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitNumberLiteral) {
			listener.exitNumberLiteral(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitNumberLiteral) {
			return visitor.visitNumberLiteral(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class StringLiteralContext extends ExprContext {
	public STRING(): TerminalNode { return this.getToken(ManimParser.STRING, 0); }
	constructor(ctx: ExprContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterStringLiteral) {
			listener.enterStringLiteral(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitStringLiteral) {
			listener.exitStringLiteral(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitStringLiteral) {
			return visitor.visitStringLiteral(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class NullLiteralContext extends ExprContext {
	public NULL(): TerminalNode { return this.getToken(ManimParser.NULL, 0); }
	constructor(ctx: ExprContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterNullLiteral) {
			listener.enterNullLiteral(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitNullLiteral) {
			listener.exitNullLiteral(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitNullLiteral) {
			return visitor.visitNullLiteral(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class BooleanLiteralContext extends ExprContext {
	public bool(): BoolContext {
		return this.getRuleContext(0, BoolContext);
	}
	constructor(ctx: ExprContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterBooleanLiteral) {
			listener.enterBooleanLiteral(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitBooleanLiteral) {
			listener.exitBooleanLiteral(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitBooleanLiteral) {
			return visitor.visitBooleanLiteral(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class CharacterLiteralContext extends ExprContext {
	public CHAR_LITER(): TerminalNode { return this.getToken(ManimParser.CHAR_LITER, 0); }
	constructor(ctx: ExprContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterCharacterLiteral) {
			listener.enterCharacterLiteral(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitCharacterLiteral) {
			listener.exitCharacterLiteral(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitCharacterLiteral) {
			return visitor.visitCharacterLiteral(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class IdentifierContext extends ExprContext {
	public IDENT(): TerminalNode { return this.getToken(ManimParser.IDENT, 0); }
	constructor(ctx: ExprContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterIdentifier) {
			listener.enterIdentifier(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitIdentifier) {
			listener.exitIdentifier(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitIdentifier) {
			return visitor.visitIdentifier(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class ArrayElemExprContext extends ExprContext {
	public array_elem(): Array_elemContext {
		return this.getRuleContext(0, Array_elemContext);
	}
	constructor(ctx: ExprContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterArrayElemExpr) {
			listener.enterArrayElemExpr(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitArrayElemExpr) {
			listener.exitArrayElemExpr(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitArrayElemExpr) {
			return visitor.visitArrayElemExpr(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class NodeElemExprContext extends ExprContext {
	public node_elem(): Node_elemContext {
		return this.getRuleContext(0, Node_elemContext);
	}
	constructor(ctx: ExprContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterNodeElemExpr) {
			listener.enterNodeElemExpr(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitNodeElemExpr) {
			listener.exitNodeElemExpr(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitNodeElemExpr) {
			return visitor.visitNodeElemExpr(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class DataStructureConstructorContext extends ExprContext {
	public data_structure_type(): Data_structure_typeContext {
		return this.getRuleContext(0, Data_structure_typeContext);
	}
	public OPEN_PARENTHESIS(): TerminalNode { return this.getToken(ManimParser.OPEN_PARENTHESIS, 0); }
	public CLOSE_PARENTHESIS(): TerminalNode { return this.getToken(ManimParser.CLOSE_PARENTHESIS, 0); }
	public arg_list(): Arg_listContext | undefined {
		return this.tryGetRuleContext(0, Arg_listContext);
	}
	public data_structure_initialiser(): Data_structure_initialiserContext | undefined {
		return this.tryGetRuleContext(0, Data_structure_initialiserContext);
	}
	constructor(ctx: ExprContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterDataStructureConstructor) {
			listener.enterDataStructureConstructor(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitDataStructureConstructor) {
			listener.exitDataStructureConstructor(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitDataStructureConstructor) {
			return visitor.visitDataStructureConstructor(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class MethodCallExpressionContext extends ExprContext {
	public method_call(): Method_callContext {
		return this.getRuleContext(0, Method_callContext);
	}
	constructor(ctx: ExprContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterMethodCallExpression) {
			listener.enterMethodCallExpression(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitMethodCallExpression) {
			listener.exitMethodCallExpression(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitMethodCallExpression) {
			return visitor.visitMethodCallExpression(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class UnaryOperatorContext extends ExprContext {
	public _unary_operator: Token;
	public expr(): ExprContext {
		return this.getRuleContext(0, ExprContext);
	}
	public ADD(): TerminalNode | undefined { return this.tryGetToken(ManimParser.ADD, 0); }
	public MINUS(): TerminalNode | undefined { return this.tryGetToken(ManimParser.MINUS, 0); }
	public NOT(): TerminalNode | undefined { return this.tryGetToken(ManimParser.NOT, 0); }
	constructor(ctx: ExprContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterUnaryOperator) {
			listener.enterUnaryOperator(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitUnaryOperator) {
			listener.exitUnaryOperator(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitUnaryOperator) {
			return visitor.visitUnaryOperator(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class BinaryExpressionContext extends ExprContext {
	public _left: ExprContext;
	public _binary_operator: Token;
	public _right: ExprContext;
	public expr(): ExprContext[];
	public expr(i: number): ExprContext;
	public expr(i?: number): ExprContext | ExprContext[] {
		if (i === undefined) {
			return this.getRuleContexts(ExprContext);
		} else {
			return this.getRuleContext(i, ExprContext);
		}
	}
	public ADD(): TerminalNode | undefined { return this.tryGetToken(ManimParser.ADD, 0); }
	public MINUS(): TerminalNode | undefined { return this.tryGetToken(ManimParser.MINUS, 0); }
	public TIMES(): TerminalNode | undefined { return this.tryGetToken(ManimParser.TIMES, 0); }
	public DIVIDE(): TerminalNode | undefined { return this.tryGetToken(ManimParser.DIVIDE, 0); }
	public GT(): TerminalNode | undefined { return this.tryGetToken(ManimParser.GT, 0); }
	public GE(): TerminalNode | undefined { return this.tryGetToken(ManimParser.GE, 0); }
	public LE(): TerminalNode | undefined { return this.tryGetToken(ManimParser.LE, 0); }
	public LT(): TerminalNode | undefined { return this.tryGetToken(ManimParser.LT, 0); }
	public EQ(): TerminalNode | undefined { return this.tryGetToken(ManimParser.EQ, 0); }
	public NEQ(): TerminalNode | undefined { return this.tryGetToken(ManimParser.NEQ, 0); }
	public AND(): TerminalNode | undefined { return this.tryGetToken(ManimParser.AND, 0); }
	public OR(): TerminalNode | undefined { return this.tryGetToken(ManimParser.OR, 0); }
	constructor(ctx: ExprContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterBinaryExpression) {
			listener.enterBinaryExpression(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitBinaryExpression) {
			listener.exitBinaryExpression(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitBinaryExpression) {
			return visitor.visitBinaryExpression(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class CastExpressionContext extends ExprContext {
	public cast_method(): Cast_methodContext {
		return this.getRuleContext(0, Cast_methodContext);
	}
	public OPEN_PARENTHESIS(): TerminalNode { return this.getToken(ManimParser.OPEN_PARENTHESIS, 0); }
	public expr(): ExprContext {
		return this.getRuleContext(0, ExprContext);
	}
	public CLOSE_PARENTHESIS(): TerminalNode { return this.getToken(ManimParser.CLOSE_PARENTHESIS, 0); }
	constructor(ctx: ExprContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterCastExpression) {
			listener.enterCastExpression(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitCastExpression) {
			listener.exitCastExpression(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitCastExpression) {
			return visitor.visitCastExpression(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class BracketedExpressionContext extends ExprContext {
	public OPEN_PARENTHESIS(): TerminalNode { return this.getToken(ManimParser.OPEN_PARENTHESIS, 0); }
	public expr(): ExprContext {
		return this.getRuleContext(0, ExprContext);
	}
	public CLOSE_PARENTHESIS(): TerminalNode { return this.getToken(ManimParser.CLOSE_PARENTHESIS, 0); }
	constructor(ctx: ExprContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterBracketedExpression) {
			listener.enterBracketedExpression(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitBracketedExpression) {
			listener.exitBracketedExpression(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitBracketedExpression) {
			return visitor.visitBracketedExpression(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class Cast_methodContext extends ParserRuleContext {
	constructor(parent: ParserRuleContext | undefined, invokingState: number) {
		super(parent, invokingState);
	}
	// @Override
	public get ruleIndex(): number { return ManimParser.RULE_cast_method; }
	public copyFrom(ctx: Cast_methodContext): void {
		super.copyFrom(ctx);
	}
}
export class ToNumberContext extends Cast_methodContext {
	public TO_NUMBER(): TerminalNode { return this.getToken(ManimParser.TO_NUMBER, 0); }
	constructor(ctx: Cast_methodContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterToNumber) {
			listener.enterToNumber(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitToNumber) {
			listener.exitToNumber(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitToNumber) {
			return visitor.visitToNumber(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class ToCharacterContext extends Cast_methodContext {
	public TO_CHAR(): TerminalNode { return this.getToken(ManimParser.TO_CHAR, 0); }
	constructor(ctx: Cast_methodContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterToCharacter) {
			listener.enterToCharacter(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitToCharacter) {
			listener.exitToCharacter(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitToCharacter) {
			return visitor.visitToCharacter(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class Method_callContext extends ParserRuleContext {
	constructor(parent: ParserRuleContext | undefined, invokingState: number) {
		super(parent, invokingState);
	}
	// @Override
	public get ruleIndex(): number { return ManimParser.RULE_method_call; }
	public copyFrom(ctx: Method_callContext): void {
		super.copyFrom(ctx);
	}
}
export class MethodCallContext extends Method_callContext {
	public IDENT(): TerminalNode[];
	public IDENT(i: number): TerminalNode;
	public IDENT(i?: number): TerminalNode | TerminalNode[] {
		if (i === undefined) {
			return this.getTokens(ManimParser.IDENT);
		} else {
			return this.getToken(ManimParser.IDENT, i);
		}
	}
	public DOT(): TerminalNode { return this.getToken(ManimParser.DOT, 0); }
	public OPEN_PARENTHESIS(): TerminalNode { return this.getToken(ManimParser.OPEN_PARENTHESIS, 0); }
	public CLOSE_PARENTHESIS(): TerminalNode { return this.getToken(ManimParser.CLOSE_PARENTHESIS, 0); }
	public OPEN_SQUARE_BRACKET(): TerminalNode | undefined { return this.tryGetToken(ManimParser.OPEN_SQUARE_BRACKET, 0); }
	public expr(): ExprContext | undefined {
		return this.tryGetRuleContext(0, ExprContext);
	}
	public CLOSE_SQUARE_BRACKET(): TerminalNode | undefined { return this.tryGetToken(ManimParser.CLOSE_SQUARE_BRACKET, 0); }
	public arg_list(): Arg_listContext | undefined {
		return this.tryGetRuleContext(0, Arg_listContext);
	}
	constructor(ctx: Method_callContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterMethodCall) {
			listener.enterMethodCall(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitMethodCall) {
			listener.exitMethodCall(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitMethodCall) {
			return visitor.visitMethodCall(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class FunctionCallContext extends Method_callContext {
	public IDENT(): TerminalNode { return this.getToken(ManimParser.IDENT, 0); }
	public OPEN_PARENTHESIS(): TerminalNode { return this.getToken(ManimParser.OPEN_PARENTHESIS, 0); }
	public CLOSE_PARENTHESIS(): TerminalNode { return this.getToken(ManimParser.CLOSE_PARENTHESIS, 0); }
	public arg_list(): Arg_listContext | undefined {
		return this.tryGetRuleContext(0, Arg_listContext);
	}
	constructor(ctx: Method_callContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterFunctionCall) {
			listener.enterFunctionCall(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitFunctionCall) {
			listener.exitFunctionCall(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitFunctionCall) {
			return visitor.visitFunctionCall(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class TypeContext extends ParserRuleContext {
	constructor(parent: ParserRuleContext | undefined, invokingState: number) {
		super(parent, invokingState);
	}
	// @Override
	public get ruleIndex(): number { return ManimParser.RULE_type; }
	public copyFrom(ctx: TypeContext): void {
		super.copyFrom(ctx);
	}
}
export class DataStructureTypeContext extends TypeContext {
	public data_structure_type(): Data_structure_typeContext {
		return this.getRuleContext(0, Data_structure_typeContext);
	}
	constructor(ctx: TypeContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterDataStructureType) {
			listener.enterDataStructureType(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitDataStructureType) {
			listener.exitDataStructureType(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitDataStructureType) {
			return visitor.visitDataStructureType(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class PrimitiveTypeContext extends TypeContext {
	public primitive_type(): Primitive_typeContext {
		return this.getRuleContext(0, Primitive_typeContext);
	}
	constructor(ctx: TypeContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterPrimitiveType) {
			listener.enterPrimitiveType(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitPrimitiveType) {
			listener.exitPrimitiveType(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitPrimitiveType) {
			return visitor.visitPrimitiveType(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class Node_typeContext extends ParserRuleContext {
	public TREE_NODE(): TerminalNode { return this.getToken(ManimParser.TREE_NODE, 0); }
	public LT(): TerminalNode { return this.getToken(ManimParser.LT, 0); }
	public primitive_type(): Primitive_typeContext {
		return this.getRuleContext(0, Primitive_typeContext);
	}
	public GT(): TerminalNode { return this.getToken(ManimParser.GT, 0); }
	constructor(parent: ParserRuleContext | undefined, invokingState: number) {
		super(parent, invokingState);
	}
	// @Override
	public get ruleIndex(): number { return ManimParser.RULE_node_type; }
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterNode_type) {
			listener.enterNode_type(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitNode_type) {
			listener.exitNode_type(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitNode_type) {
			return visitor.visitNode_type(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class Data_structure_typeContext extends ParserRuleContext {
	constructor(parent: ParserRuleContext | undefined, invokingState: number) {
		super(parent, invokingState);
	}
	// @Override
	public get ruleIndex(): number { return ManimParser.RULE_data_structure_type; }
	public copyFrom(ctx: Data_structure_typeContext): void {
		super.copyFrom(ctx);
	}
}
export class StackTypeContext extends Data_structure_typeContext {
	public STACK(): TerminalNode { return this.getToken(ManimParser.STACK, 0); }
	public LT(): TerminalNode { return this.getToken(ManimParser.LT, 0); }
	public primitive_type(): Primitive_typeContext {
		return this.getRuleContext(0, Primitive_typeContext);
	}
	public GT(): TerminalNode { return this.getToken(ManimParser.GT, 0); }
	constructor(ctx: Data_structure_typeContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterStackType) {
			listener.enterStackType(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitStackType) {
			listener.exitStackType(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitStackType) {
			return visitor.visitStackType(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class ArrayTypeContext extends Data_structure_typeContext {
	public type(): TypeContext {
		return this.getRuleContext(0, TypeContext);
	}
	public ARRAY(): TerminalNode[];
	public ARRAY(i: number): TerminalNode;
	public ARRAY(i?: number): TerminalNode | TerminalNode[] {
		if (i === undefined) {
			return this.getTokens(ManimParser.ARRAY);
		} else {
			return this.getToken(ManimParser.ARRAY, i);
		}
	}
	public LT(): TerminalNode[];
	public LT(i: number): TerminalNode;
	public LT(i?: number): TerminalNode | TerminalNode[] {
		if (i === undefined) {
			return this.getTokens(ManimParser.LT);
		} else {
			return this.getToken(ManimParser.LT, i);
		}
	}
	public GT(): TerminalNode[];
	public GT(i: number): TerminalNode;
	public GT(i?: number): TerminalNode | TerminalNode[] {
		if (i === undefined) {
			return this.getTokens(ManimParser.GT);
		} else {
			return this.getToken(ManimParser.GT, i);
		}
	}
	constructor(ctx: Data_structure_typeContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterArrayType) {
			listener.enterArrayType(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitArrayType) {
			listener.exitArrayType(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitArrayType) {
			return visitor.visitArrayType(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class ListTypeContext extends Data_structure_typeContext {
	public LIST(): TerminalNode { return this.getToken(ManimParser.LIST, 0); }
	public LT(): TerminalNode { return this.getToken(ManimParser.LT, 0); }
	public type(): TypeContext {
		return this.getRuleContext(0, TypeContext);
	}
	public GT(): TerminalNode { return this.getToken(ManimParser.GT, 0); }
	constructor(ctx: Data_structure_typeContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterListType) {
			listener.enterListType(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitListType) {
			listener.exitListType(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitListType) {
			return visitor.visitListType(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class NodeTypeContext extends Data_structure_typeContext {
	public node_type(): Node_typeContext {
		return this.getRuleContext(0, Node_typeContext);
	}
	constructor(ctx: Data_structure_typeContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterNodeType) {
			listener.enterNodeType(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitNodeType) {
			listener.exitNodeType(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitNodeType) {
			return visitor.visitNodeType(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class TreeTypeContext extends Data_structure_typeContext {
	public TREE(): TerminalNode { return this.getToken(ManimParser.TREE, 0); }
	public LT(): TerminalNode { return this.getToken(ManimParser.LT, 0); }
	public node_type(): Node_typeContext {
		return this.getRuleContext(0, Node_typeContext);
	}
	public GT(): TerminalNode { return this.getToken(ManimParser.GT, 0); }
	constructor(ctx: Data_structure_typeContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterTreeType) {
			listener.enterTreeType(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitTreeType) {
			listener.exitTreeType(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitTreeType) {
			return visitor.visitTreeType(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class Primitive_typeContext extends ParserRuleContext {
	constructor(parent: ParserRuleContext | undefined, invokingState: number) {
		super(parent, invokingState);
	}
	// @Override
	public get ruleIndex(): number { return ManimParser.RULE_primitive_type; }
	public copyFrom(ctx: Primitive_typeContext): void {
		super.copyFrom(ctx);
	}
}
export class NumberTypeContext extends Primitive_typeContext {
	public NUMBER_TYPE(): TerminalNode { return this.getToken(ManimParser.NUMBER_TYPE, 0); }
	constructor(ctx: Primitive_typeContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterNumberType) {
			listener.enterNumberType(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitNumberType) {
			listener.exitNumberType(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitNumberType) {
			return visitor.visitNumberType(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class BoolTypeContext extends Primitive_typeContext {
	public BOOL_TYPE(): TerminalNode { return this.getToken(ManimParser.BOOL_TYPE, 0); }
	constructor(ctx: Primitive_typeContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterBoolType) {
			listener.enterBoolType(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitBoolType) {
			listener.exitBoolType(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitBoolType) {
			return visitor.visitBoolType(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class CharTypeContext extends Primitive_typeContext {
	public CHAR_TYPE(): TerminalNode { return this.getToken(ManimParser.CHAR_TYPE, 0); }
	constructor(ctx: Primitive_typeContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterCharType) {
			listener.enterCharType(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitCharType) {
			listener.exitCharType(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitCharType) {
			return visitor.visitCharType(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class StringTypeContext extends Primitive_typeContext {
	public STRING_TYPE(): TerminalNode { return this.getToken(ManimParser.STRING_TYPE, 0); }
	constructor(ctx: Primitive_typeContext) {
		super(ctx.parent, ctx.invokingState);
		this.copyFrom(ctx);
	}
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterStringType) {
			listener.enterStringType(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitStringType) {
			listener.exitStringType(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitStringType) {
			return visitor.visitStringType(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class BoolContext extends ParserRuleContext {
	public TRUE(): TerminalNode | undefined { return this.tryGetToken(ManimParser.TRUE, 0); }
	public FALSE(): TerminalNode | undefined { return this.tryGetToken(ManimParser.FALSE, 0); }
	constructor(parent: ParserRuleContext | undefined, invokingState: number) {
		super(parent, invokingState);
	}
	// @Override
	public get ruleIndex(): number { return ManimParser.RULE_bool; }
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterBool) {
			listener.enterBool(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitBool) {
			listener.exitBool(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitBool) {
			return visitor.visitBool(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class Data_structure_initialiserContext extends ParserRuleContext {
	public OPEN_CURLY_BRACKET(): TerminalNode { return this.getToken(ManimParser.OPEN_CURLY_BRACKET, 0); }
	public CLOSE_CURLY_BRACKET(): TerminalNode { return this.getToken(ManimParser.CLOSE_CURLY_BRACKET, 0); }
	public arg_list(): Arg_listContext | undefined {
		return this.tryGetRuleContext(0, Arg_listContext);
	}
	public initialiser_list(): Initialiser_listContext | undefined {
		return this.tryGetRuleContext(0, Initialiser_listContext);
	}
	constructor(parent: ParserRuleContext | undefined, invokingState: number) {
		super(parent, invokingState);
	}
	// @Override
	public get ruleIndex(): number { return ManimParser.RULE_data_structure_initialiser; }
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterData_structure_initialiser) {
			listener.enterData_structure_initialiser(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitData_structure_initialiser) {
			listener.exitData_structure_initialiser(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitData_structure_initialiser) {
			return visitor.visitData_structure_initialiser(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class Initialiser_listContext extends ParserRuleContext {
	public OPEN_SQUARE_BRACKET(): TerminalNode[];
	public OPEN_SQUARE_BRACKET(i: number): TerminalNode;
	public OPEN_SQUARE_BRACKET(i?: number): TerminalNode | TerminalNode[] {
		if (i === undefined) {
			return this.getTokens(ManimParser.OPEN_SQUARE_BRACKET);
		} else {
			return this.getToken(ManimParser.OPEN_SQUARE_BRACKET, i);
		}
	}
	public arg_list(): Arg_listContext[];
	public arg_list(i: number): Arg_listContext;
	public arg_list(i?: number): Arg_listContext | Arg_listContext[] {
		if (i === undefined) {
			return this.getRuleContexts(Arg_listContext);
		} else {
			return this.getRuleContext(i, Arg_listContext);
		}
	}
	public CLOSE_SQUARE_BRACKET(): TerminalNode[];
	public CLOSE_SQUARE_BRACKET(i: number): TerminalNode;
	public CLOSE_SQUARE_BRACKET(i?: number): TerminalNode | TerminalNode[] {
		if (i === undefined) {
			return this.getTokens(ManimParser.CLOSE_SQUARE_BRACKET);
		} else {
			return this.getToken(ManimParser.CLOSE_SQUARE_BRACKET, i);
		}
	}
	public COMMA(): TerminalNode[];
	public COMMA(i: number): TerminalNode;
	public COMMA(i?: number): TerminalNode | TerminalNode[] {
		if (i === undefined) {
			return this.getTokens(ManimParser.COMMA);
		} else {
			return this.getToken(ManimParser.COMMA, i);
		}
	}
	constructor(parent: ParserRuleContext | undefined, invokingState: number) {
		super(parent, invokingState);
	}
	// @Override
	public get ruleIndex(): number { return ManimParser.RULE_initialiser_list; }
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterInitialiser_list) {
			listener.enterInitialiser_list(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitInitialiser_list) {
			listener.exitInitialiser_list(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitInitialiser_list) {
			return visitor.visitInitialiser_list(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class Array_elemContext extends ParserRuleContext {
	public IDENT(): TerminalNode { return this.getToken(ManimParser.IDENT, 0); }
	public OPEN_SQUARE_BRACKET(): TerminalNode[];
	public OPEN_SQUARE_BRACKET(i: number): TerminalNode;
	public OPEN_SQUARE_BRACKET(i?: number): TerminalNode | TerminalNode[] {
		if (i === undefined) {
			return this.getTokens(ManimParser.OPEN_SQUARE_BRACKET);
		} else {
			return this.getToken(ManimParser.OPEN_SQUARE_BRACKET, i);
		}
	}
	public expr(): ExprContext[];
	public expr(i: number): ExprContext;
	public expr(i?: number): ExprContext | ExprContext[] {
		if (i === undefined) {
			return this.getRuleContexts(ExprContext);
		} else {
			return this.getRuleContext(i, ExprContext);
		}
	}
	public CLOSE_SQUARE_BRACKET(): TerminalNode[];
	public CLOSE_SQUARE_BRACKET(i: number): TerminalNode;
	public CLOSE_SQUARE_BRACKET(i?: number): TerminalNode | TerminalNode[] {
		if (i === undefined) {
			return this.getTokens(ManimParser.CLOSE_SQUARE_BRACKET);
		} else {
			return this.getToken(ManimParser.CLOSE_SQUARE_BRACKET, i);
		}
	}
	constructor(parent: ParserRuleContext | undefined, invokingState: number) {
		super(parent, invokingState);
	}
	// @Override
	public get ruleIndex(): number { return ManimParser.RULE_array_elem; }
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterArray_elem) {
			listener.enterArray_elem(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitArray_elem) {
			listener.exitArray_elem(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitArray_elem) {
			return visitor.visitArray_elem(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class Node_elemContext extends ParserRuleContext {
	public IDENT(): TerminalNode { return this.getToken(ManimParser.IDENT, 0); }
	public node_elem_access(): Node_elem_accessContext[];
	public node_elem_access(i: number): Node_elem_accessContext;
	public node_elem_access(i?: number): Node_elem_accessContext | Node_elem_accessContext[] {
		if (i === undefined) {
			return this.getRuleContexts(Node_elem_accessContext);
		} else {
			return this.getRuleContext(i, Node_elem_accessContext);
		}
	}
	constructor(parent: ParserRuleContext | undefined, invokingState: number) {
		super(parent, invokingState);
	}
	// @Override
	public get ruleIndex(): number { return ManimParser.RULE_node_elem; }
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterNode_elem) {
			listener.enterNode_elem(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitNode_elem) {
			listener.exitNode_elem(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitNode_elem) {
			return visitor.visitNode_elem(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class Node_elem_accessContext extends ParserRuleContext {
	public DOT(): TerminalNode | undefined { return this.tryGetToken(ManimParser.DOT, 0); }
	public IDENT(): TerminalNode | undefined { return this.tryGetToken(ManimParser.IDENT, 0); }
	constructor(parent: ParserRuleContext | undefined, invokingState: number) {
		super(parent, invokingState);
	}
	// @Override
	public get ruleIndex(): number { return ManimParser.RULE_node_elem_access; }
	// @Override
	public enterRule(listener: ManimParserListener): void {
		if (listener.enterNode_elem_access) {
			listener.enterNode_elem_access(this);
		}
	}
	// @Override
	public exitRule(listener: ManimParserListener): void {
		if (listener.exitNode_elem_access) {
			listener.exitNode_elem_access(this);
		}
	}
	// @Override
	public accept<Result>(visitor: ManimParserVisitor<Result>): Result {
		if (visitor.visitNode_elem_access) {
			return visitor.visitNode_elem_access(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


